import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, HostListener, inject, ViewChild, Optional, NgModule, Injectable, InjectionToken, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@spartacus/core';
import { GlobalMessageType, RoutingService, UrlModule, I18nModule, FeaturesConfigModule, provideDefaultConfig, AuthGuard, OAuthFlow, NotAuthGuard, AuthConfigService, GlobalMessageService, FeatureConfigService, useFeatureStyles, HttpErrorModel, AuthService, AuthRedirectService, provideDefaultConfigFactory, UserAddressService, AnonymousConsentsService, AnonymousConsentsConfig, ClientAuthenticationTokenService } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { ICON_TYPE, DIALOG_TYPE, IconModule, SpinnerModule, KeyboardFocusModule, BtnLikeLinkModule, CustomFormValidators, FormErrorsModule, sortTitles, CaptchaModule, NgSelectA11yModule, PasswordVisibilityToggleModule, MessageComponentModule, getAddressNumbers, CardModule, PageSlotModule, LaunchDialogService } from '@spartacus/storefront';
import { BehaviorSubject, Subscription, combineLatest, Subject, map as map$1, filter as filter$1 } from 'rxjs';
import { first, take, tap, map, filter, switchMap } from 'rxjs/operators';
import * as i1 from '@spartacus/user/profile/root';
import { UserPasswordFacade, UserRegisterFacade, UserProfileFacade, UserEmailFacade } from '@spartacus/user/profile/root';
import * as i3 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, UntypedFormBuilder, FormsModule } from '@angular/forms';
import * as i6 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { VerificationTokenFacade } from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function CloseAccountModalComponent_ng_container_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵelement(2, "cx-spinner");
    i0.ɵɵelementEnd()();
  }
}
function CloseAccountModalComponent_ng_container_0_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "p", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 13)(5, "button", 14);
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_ng_template_14_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeAccount());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 15);
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_ng_template_14_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cancel"));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "closeAccount.confirmAccountClosureMessage"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "closeAccount.closeMyAccount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 7, "common.cancel"), " ");
  }
}
function CloseAccountModalComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("esc", function CloseAccountModalComponent_ng_container_0_Template_div_esc_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Escape click"));
    });
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "h3", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 6);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cross click"));
    });
    i0.ɵɵelementStart(10, "span", 7);
    i0.ɵɵelement(11, "cx-icon", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, CloseAccountModalComponent_ng_container_0_div_12_Template, 3, 0, "div", 9);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵtemplate(14, CloseAccountModalComponent_ng_container_0_ng_template_14_Template, 11, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const loaded_r4 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "closeAccount.confirmAccountClosure"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 9, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 11, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 13, ctx_r1.isLoading$))("ngIfElse", loaded_r4);
  }
}
const _c0 = ["element"];
const _c1 = () => ({
  cxRoute: "home"
});
function CloseAccountComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 6);
    i0.ɵɵlistener("click", function CloseAccountComponent_ng_container_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function CloseAccountComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
const _c2 = a0 => ({
  label: a0
});
const _c3 = () => ({
  cxRoute: "login"
});
function ForgotPasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 10);
  }
}
function ForgotPasswordComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), "\n");
  }
}
function ForgotPasswordComponent_abbr_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 12);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function ForgotPasswordComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 13);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "forgottenPassword.emailAddress.label")))("control", ctx_r0.form.get("userEmail"));
  }
}
function ForgotPasswordComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("userEmail"));
  }
}
function ForgotPasswordComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 15);
    i0.ɵɵlistener("click", function ForgotPasswordComponent_ng_container_13_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.navigateTo("login"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function ForgotPasswordComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 16);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
const _c4 = () => ({});
const _c5 = () => ({
  cxRoute: "termsAndConditions"
});
function RegisterComponent_section_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 37);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function RegisterComponent_section_0_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 38);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function RegisterComponent_section_0_ng_template_20_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 39);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.firstName.label")))("control", ctx_r1.registerForm.get("firstName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("firstName"));
  }
}
function RegisterComponent_section_0_ng_template_30_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 40);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.lastName.label")))("control", ctx_r1.registerForm.get("lastName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("lastName"));
  }
}
function RegisterComponent_section_0_ng_template_40_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 41);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.emailAddress.label")))("control", ctx_r1.registerForm.get("email"));
  }
}
function RegisterComponent_section_0_cx_form_errors_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("email"));
  }
}
function RegisterComponent_section_0_ng_template_50_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 42);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.password.label")))("control", ctx_r1.registerForm.get("password"));
  }
}
function RegisterComponent_section_0_cx_form_errors_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("password"));
  }
}
function RegisterComponent_section_0_ng_template_64_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_68_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 43);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.confirmPassword.label")))("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegisterComponent_section_0_cx_form_errors_69_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegisterComponent_section_0_label_72_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵelement(1, "input", 44);
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const anonymousConsent_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isConsentGiven(anonymousConsent_r3.consent));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", anonymousConsent_r3.template, " ");
  }
}
function RegisterComponent_section_0_div_74_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "input", 47);
    i0.ɵɵlistener("change", function RegisterComponent_section_0_div_74_div_1_div_1_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r5 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateAdditionalConsents($event, i_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 30);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-form-errors", 34);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const id_r6 = ctx.ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    const control_r8 = ctx_r6.$implicit;
    const i_r5 = ctx_r6.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", consents_r9[i_r5].required)("name", id_r6)("formControlName", i_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consents_r9[i_r5].template.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", control_r8);
  }
}
function RegisterComponent_section_0_div_74_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_74_div_1_div_1_Template, 6, 5, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consents_r9[i_r5] == null ? null : consents_r9[i_r5].template == null ? null : consents_r9[i_r5].template.id);
  }
}
function RegisterComponent_section_0_div_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_74_div_1_Template, 2, 1, "div", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.additionalConsents.controls);
  }
}
function RegisterComponent_section_0_ng_template_86_Template(rf, ctx) {}
function RegisterComponent_section_0_cx_form_errors_87_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 48);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.termsAndConditions")))("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function RegisterComponent_section_0_cx_form_errors_88_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function RegisterComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 3);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_1_Template, 2, 3, "div", 4);
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7);
    i0.ɵɵtemplate(5, RegisterComponent_section_0_p_5_Template, 3, 3, "p", 8);
    i0.ɵɵelementStart(6, "form", 9);
    i0.ɵɵlistener("ngSubmit", function RegisterComponent_section_0_Template_form_ngSubmit_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm());
    });
    i0.ɵɵelementStart(7, "div", 10)(8, "label")(9, "span", 11);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "ng-select", 12);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 10)(16, "label")(17, "span", 11);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵtemplate(20, RegisterComponent_section_0_ng_template_20_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 14);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵtemplate(23, RegisterComponent_section_0_cx_form_errors_23_Template, 2, 6, "cx-form-errors", 15)(24, RegisterComponent_section_0_cx_form_errors_24_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 10)(26, "label")(27, "span", 11);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵtemplate(30, RegisterComponent_section_0_ng_template_30_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "input", 17);
    i0.ɵɵpipe(32, "cxTranslate");
    i0.ɵɵtemplate(33, RegisterComponent_section_0_cx_form_errors_33_Template, 2, 6, "cx-form-errors", 18)(34, RegisterComponent_section_0_cx_form_errors_34_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 10)(36, "label")(37, "span", 11);
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵtemplate(40, RegisterComponent_section_0_ng_template_40_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "input", 19);
    i0.ɵɵpipe(42, "cxTranslate");
    i0.ɵɵtemplate(43, RegisterComponent_section_0_cx_form_errors_43_Template, 2, 6, "cx-form-errors", 20)(44, RegisterComponent_section_0_cx_form_errors_44_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 10)(46, "label")(47, "span", 11);
    i0.ɵɵtext(48);
    i0.ɵɵpipe(49, "cxTranslate");
    i0.ɵɵtemplate(50, RegisterComponent_section_0_ng_template_50_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(51, "input", 21);
    i0.ɵɵpipe(52, "cxTranslate");
    i0.ɵɵpipe(53, "cxTranslate");
    i0.ɵɵelementStart(54, "p", 22);
    i0.ɵɵtext(55);
    i0.ɵɵpipe(56, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, RegisterComponent_section_0_cx_form_errors_57_Template, 2, 6, "cx-form-errors", 23)(58, RegisterComponent_section_0_cx_form_errors_58_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(59, "div", 10)(60, "label")(61, "span", 11);
    i0.ɵɵtext(62);
    i0.ɵɵpipe(63, "cxTranslate");
    i0.ɵɵtemplate(64, RegisterComponent_section_0_ng_template_64_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(65, "input", 24);
    i0.ɵɵpipe(66, "cxTranslate");
    i0.ɵɵpipe(67, "cxTranslate");
    i0.ɵɵtemplate(68, RegisterComponent_section_0_cx_form_errors_68_Template, 2, 6, "cx-form-errors", 25)(69, RegisterComponent_section_0_cx_form_errors_69_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(70, "div", 10)(71, "div", 26);
    i0.ɵɵtemplate(72, RegisterComponent_section_0_label_72_Template, 4, 2, "label", 27);
    i0.ɵɵpipe(73, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(74, RegisterComponent_section_0_div_74_Template, 2, 1, "div", 28);
    i0.ɵɵelementStart(75, "div", 10)(76, "div", 26)(77, "label");
    i0.ɵɵelement(78, "input", 29);
    i0.ɵɵelementStart(79, "span", 30);
    i0.ɵɵtext(80);
    i0.ɵɵpipe(81, "cxTranslate");
    i0.ɵɵelementStart(82, "a", 31);
    i0.ɵɵpipe(83, "cxUrl");
    i0.ɵɵtext(84);
    i0.ɵɵpipe(85, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(86, RegisterComponent_section_0_ng_template_86_Template, 0, 0, "ng-template", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(87, RegisterComponent_section_0_cx_form_errors_87_Template, 2, 6, "cx-form-errors", 32)(88, RegisterComponent_section_0_cx_form_errors_88_Template, 1, 1, "cx-form-errors", 16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(89, "cx-captcha", 33);
    i0.ɵɵlistener("confirmed", function RegisterComponent_section_0_Template_cx_captcha_confirmed_89_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.captchaConfirmed());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(90, "cx-form-errors", 34);
    i0.ɵɵelementStart(91, "button", 35);
    i0.ɵɵtext(92);
    i0.ɵɵpipe(93, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(94, "a", 36);
    i0.ɵɵpipe(95, "cxUrl");
    i0.ɵɵtext(96);
    i0.ɵɵpipe(97, "cxTranslate");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const requiredAsterisk_r10 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.registerForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 54, "register.titleOptional"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("items", i0.ɵɵpipeBind1(13, 56, ctx_r1.titles$))("placeholder", i0.ɵɵpipeBind1(14, 58, "register.selectTitle"))("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction0(100, _c4));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(19, 60, "register.firstName.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 62, "register.firstName.placeholder"));
    i0.ɵɵattribute("aria-describedby", "firstNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(29, 64, "register.lastName.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(32, 66, "register.lastName.placeholder"));
    i0.ɵɵattribute("aria-describedby", "lastNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(39, 68, "register.emailAddress.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(42, 70, "register.emailAddress.placeholder"));
    i0.ɵɵattribute("aria-describedby", "emailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(49, 72, "register.password.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(52, 74, "register.password.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(53, 76, "register.password.placeholder"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(56, 78, "register.passwordMinRequirements"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(63, 80, "register.confirmPassword.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(66, 82, "register.confirmPassword.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(67, 84, "register.confirmPassword.placeholder"))("aria-describedby", "passwordconfError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(73, 86, ctx_r1.anonymousConsent$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.additionalRegistrationConsents);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-describedby", "termsandconditionsError");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(81, 88, "register.confirmThatRead"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(83, 90, i0.ɵɵpureFunction0(101, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(85, 92, "register.termsAndConditions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("captcha"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(93, 94, "register.register"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(95, 96, i0.ɵɵpureFunction0(102, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(97, 98, "register.signIn"));
  }
}
function RegisterComponent_ng_template_2_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 50);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function RegisterComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegisterComponent_ng_template_2_abbr_0_Template, 3, 3, "abbr", 49);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function RegisterComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ResetPasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 3);
  }
}
function ResetPasswordComponent_form_2_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function ResetPasswordComponent_form_2_ng_template_6_Template(rf, ctx) {}
function ResetPasswordComponent_form_2_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.newPassword")))("control", ctx_r2.form.get("password"));
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r2.form.get("password"));
  }
}
function ResetPasswordComponent_form_2_ng_template_16_Template(rf, ctx) {}
function ResetPasswordComponent_form_2_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.passwordMinRequirements")))("control", ctx_r2.form.get("passwordConfirm"));
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r2.form.get("passwordConfirm"));
  }
}
function ResetPasswordComponent_form_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 4);
    i0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_form_2_Template_form_ngSubmit_0_listener() {
      const token_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onSubmit(token_r2));
    });
    i0.ɵɵtemplate(1, ResetPasswordComponent_form_2_p_1_Template, 3, 3, "p", 5);
    i0.ɵɵelementStart(2, "label")(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵtemplate(6, ResetPasswordComponent_form_2_ng_template_6_Template, 0, 0, "ng-template", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 8);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵtemplate(10, ResetPasswordComponent_form_2_cx_form_errors_10_Template, 2, 6, "cx-form-errors", 9)(11, ResetPasswordComponent_form_2_cx_form_errors_11_Template, 1, 1, "cx-form-errors", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label")(13, "span", 6);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵtemplate(16, ResetPasswordComponent_form_2_ng_template_16_Template, 0, 0, "ng-template", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "input", 11);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵtemplate(20, ResetPasswordComponent_form_2_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 12)(21, ResetPasswordComponent_form_2_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 13);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const requiredAsterisk_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 18, "register.newPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 20, "register.password.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 22, "register.password.placeholder"))("aria-describedby", "passwordError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 24, "register.passwordMinRequirements"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 26, "register.confirmPassword.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 28, "register.confirmPassword.placeholder"))("aria-describedby", "passwordConfirmError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 30, "register.resetPassword"), " ");
  }
}
function ResetPasswordComponent_ng_template_4_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 19);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function ResetPasswordComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ResetPasswordComponent_ng_template_4_abbr_0_Template, 3, 3, "abbr", 18);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function UpdateEmailComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 15);
  }
}
function UpdateEmailComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), "\n");
  }
}
function UpdateEmailComponent_ng_template_8_Template(rf, ctx) {}
function UpdateEmailComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.newEmailAddress.label")))("control", ctx_r1.form.get("email"));
  }
}
function UpdateEmailComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("email"));
  }
}
function UpdateEmailComponent_ng_template_17_Template(rf, ctx) {}
function UpdateEmailComponent_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.confirmNewEmailAddress.label")))("control", ctx_r1.form.get("confirmEmail"));
  }
}
function UpdateEmailComponent_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("confirmEmail"));
  }
}
function UpdateEmailComponent_ng_template_26_Template(rf, ctx) {}
function UpdateEmailComponent_cx_form_errors_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.password.label")))("control", ctx_r1.form.get("password"));
  }
}
function UpdateEmailComponent_cx_form_errors_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("password"));
  }
}
function UpdateEmailComponent_ng_template_39_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 22);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function UpdateEmailComponent_ng_template_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UpdateEmailComponent_ng_template_39_abbr_0_Template, 3, 3, "abbr", 21);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function MyAccountV2EmailComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 7);
  }
}
function MyAccountV2EmailComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.edit"), " ");
  }
}
function MyAccountV2EmailComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "label", 9);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 10);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "myAccountV2Email.email"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_2_0 = i0.ɵɵpipeBind1(7, 4, ctx_r1.user$)) == null ? null : tmp_2_0.uid, " ");
  }
}
function MyAccountV2EmailComponent_cx_message_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 11);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function MyAccountV2EmailComponent_cx_message_11_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialogConfirmationAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "myAccountV2Email.reloginIndicator"))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.newEmailAddress.label")))("control", ctx_r1.form.get("email"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("email"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 28);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.confirmNewEmailAddress.label")))("control", ctx_r1.form.get("confirmEmail"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("confirmEmail"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.password.label")))("control", ctx_r1.form.get("password"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("password"));
  }
}
function MyAccountV2EmailComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "form", 13);
    i0.ɵɵlistener("ngSubmit", function MyAccountV2EmailComponent_div_12_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "label")(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 14);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label")(9, "span", 9);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 15);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵtemplate(14, MyAccountV2EmailComponent_div_12_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 16)(15, MyAccountV2EmailComponent_div_12_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "label")(17, "span", 9);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 18);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵtemplate(22, MyAccountV2EmailComponent_div_12_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 19)(23, MyAccountV2EmailComponent_div_12_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "label")(25, "span", 20);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(28, "input", 21);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵpipe(30, "cxTranslate");
    i0.ɵɵtemplate(31, MyAccountV2EmailComponent_div_12_cx_form_errors_31_Template, 2, 6, "cx-form-errors", 22)(32, MyAccountV2EmailComponent_div_12_cx_form_errors_32_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 23)(34, "button", 24);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_div_12_Template_button_click_34_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelEdit());
    });
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "button", 25);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_div_12_Template_button_click_37_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 22, "myAccountV2Email.emailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", (tmp_3_0 = i0.ɵɵpipeBind1(7, 24, ctx_r1.user$)) == null ? null : tmp_3_0.uid);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 26, "myAccountV2Email.newEmailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 28, "myAccountV2Email.emailPlaceHolder"));
    i0.ɵɵattribute("aria-describedby", "emailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 30, "myAccountV2Email.confirmNewEmailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 32, "myAccountV2Email.emailPlaceHolder"));
    i0.ɵɵattribute("aria-describedby", "confirmEmailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 34, "myAccountV2Email.password"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(29, 36, "myAccountV2Email.passwordPlaceHolder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(30, 38, "myAccountV2Email.passwordPlaceHolder"))("aria-describedby", "passwordError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 40, "common.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 42, "common.save"), " ");
  }
}
function UpdatePasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 15);
  }
}
function UpdatePasswordComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), "\n");
  }
}
function UpdatePasswordComponent_ng_template_8_Template(rf, ctx) {}
function UpdatePasswordComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.oldPassword.label")))("control", ctx_r1.form.get("oldPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("oldPassword"));
  }
}
function UpdatePasswordComponent_ng_template_18_Template(rf, ctx) {}
function UpdatePasswordComponent_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.newPassword.label")))("control", ctx_r1.form.get("newPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPassword"));
  }
}
function UpdatePasswordComponent_ng_template_28_Template(rf, ctx) {}
function UpdatePasswordComponent_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.confirmPassword.label")))("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
function UpdatePasswordComponent_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
function UpdatePasswordComponent_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵlistener("click", function UpdatePasswordComponent_ng_container_34_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function UpdatePasswordComponent_ng_container_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 22);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
function UpdatePasswordComponent_ng_template_39_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 24);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function UpdatePasswordComponent_ng_template_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UpdatePasswordComponent_ng_template_39_abbr_0_Template, 3, 3, "abbr", 23);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function MyAccountV2PasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 16);
  }
}
function MyAccountV2PasswordComponent_cx_message_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function MyAccountV2PasswordComponent_cx_message_6_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialogConfirmationAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "myAccountV2PasswordForm.reloginIndicator"))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.oldPassword.label")))("control", ctx_r1.form.get("oldPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("oldPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.newPassword.label")))("control", ctx_r1.form.get("newPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 21);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.confirmPassword.label")))("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
const _c6 = a0 => ({
  ariaLabel: a0
});
function UpdateProfileComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 17);
  }
}
function UpdateProfileComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), "\n");
  }
}
function UpdateProfileComponent_ng_option_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", title_r2.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(title_r2.name);
  }
}
function UpdateProfileComponent_ng_template_16_Template(rf, ctx) {}
function UpdateProfileComponent_cx_form_errors_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.firstName.label")))("control", ctx_r2.form.get("firstName"));
  }
}
function UpdateProfileComponent_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 21);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.form.get("firstName"));
  }
}
function UpdateProfileComponent_ng_template_25_Template(rf, ctx) {}
function UpdateProfileComponent_cx_form_errors_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 22);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.lastName.label")))("control", ctx_r2.form.get("lastName"));
  }
}
function UpdateProfileComponent_cx_form_errors_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 21);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.form.get("lastName"));
  }
}
function UpdateProfileComponent_cx_form_errors_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 23);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.customerId")))("control", ctx_r2.form.get("customerId"));
  }
}
function UpdateProfileComponent_cx_form_errors_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 21);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.form.get("customerId"));
  }
}
function UpdateProfileComponent_ng_container_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵlistener("click", function UpdateProfileComponent_ng_container_37_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function UpdateProfileComponent_ng_container_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 25);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
function UpdateProfileComponent_ng_template_42_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 27);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function UpdateProfileComponent_ng_template_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UpdateProfileComponent_ng_template_42_abbr_0_Template, 3, 3, "abbr", 26);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function MyAccountV2ProfileComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 6);
  }
}
function MyAccountV2ProfileComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.edit"), " ");
  }
}
function MyAccountV2ProfileComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "label", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 9);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 1)(9, "label", 8);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label", 9);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 1)(17, "label", 8);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 9);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_4_0;
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "myAccountV2UserProfile.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_2_0 = i0.ɵɵpipeBind1(7, 9, ctx_r1.user$)) == null ? null : tmp_2_0.title, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 11, "myAccountV2UserProfile.name"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", (tmp_4_0 = i0.ɵɵpipeBind1(14, 13, ctx_r1.user$)) == null ? null : tmp_4_0.firstName, " ", (tmp_4_0 = i0.ɵɵpipeBind1(15, 15, ctx_r1.user$)) == null ? null : tmp_4_0.lastName, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 17, "myAccountV2UserProfile.customerId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_6_0 = i0.ɵɵpipeBind1(22, 19, ctx_r1.user$)) == null ? null : tmp_6_0.customerId, " ");
  }
}
function MyAccountV2ProfileComponent_div_11_ng_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", title_r4.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(title_r4.name);
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.firstName.label")))("control", ctx_r1.form.get("firstName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("firstName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 28);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.lastName.label")))("control", ctx_r1.form.get("lastName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("lastName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.customerId")))("control", ctx_r1.form.get("customerId"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("customerId"));
  }
}
function MyAccountV2ProfileComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "form", 11);
    i0.ɵɵlistener("ngSubmit", function MyAccountV2ProfileComponent_div_11_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "label")(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 13);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵtemplate(8, MyAccountV2ProfileComponent_div_11_ng_option_8_Template, 2, 2, "ng-option", 14);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "label")(11, "span", 12);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 15);
    i0.ɵɵtemplate(15, MyAccountV2ProfileComponent_div_11_cx_form_errors_15_Template, 2, 6, "cx-form-errors", 16)(16, MyAccountV2ProfileComponent_div_11_cx_form_errors_16_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "label")(18, "span", 12);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 18);
    i0.ɵɵtemplate(22, MyAccountV2ProfileComponent_div_11_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 19)(23, MyAccountV2ProfileComponent_div_11_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "label")(25, "span", 12);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(28, "input", 20);
    i0.ɵɵtemplate(29, MyAccountV2ProfileComponent_div_11_cx_form_errors_29_Template, 2, 6, "cx-form-errors", 21)(30, MyAccountV2ProfileComponent_div_11_cx_form_errors_30_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 22)(32, "button", 23);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_div_11_Template_button_click_32_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelEdit());
    });
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "button", 24);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_div_11_Template_button_click_35_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 21, "myAccountV2UserProfile.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction1(37, _c6, i0.ɵɵpipeBind1(7, 23, "myAccountV2UserProfile.title")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(9, 25, ctx_r1.titles$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 27, "myAccountV2UserProfile.firstName"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", "firstNameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 29, "myAccountV2UserProfile.lastName"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", "lastNameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 31, "myAccountV2UserProfile.customerId"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", "customerIdError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(34, 33, "common.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(37, 35, "common.save"), " ");
  }
}
const _c7 = ["submit"];
const _c8 = () => ({
  required: "true"
});
function AddressFormComponent_p_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), "\n");
  }
}
function AddressFormComponent_ng_container_3_div_1_ng_template_5_Template(rf, ctx) {}
function AddressFormComponent_ng_container_3_div_1_cx_form_errors_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.country")))("control", ctx_r2.addressForm.get("country.isocode"));
  }
}
function AddressFormComponent_ng_container_3_div_1_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("country.isocode"));
  }
}
function AddressFormComponent_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵtemplate(5, AddressFormComponent_ng_container_3_div_1_ng_template_5_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 34);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("change", function AddressFormComponent_ng_container_3_div_1_Template_ng_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.countrySelected($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, AddressFormComponent_ng_container_3_div_1_cx_form_errors_8_Template, 2, 6, "cx-form-errors", 35)(9, AddressFormComponent_ng_container_3_div_1_cx_form_errors_9_Template, 1, 1, "cx-form-errors", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵnextContext();
    const requiredAsterisk_r5 = i0.ɵɵreference(92);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 10, "addressForm.country"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 12, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(14, _c8))("searchable", true)("clearable", false)("items", countries_r4)("cxNgSelectA11y", i0.ɵɵpureFunction0(15, _c4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
  }
}
function AddressFormComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddressFormComponent_ng_container_3_div_1_Template, 10, 16, "div", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const countries_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", countries_r4.length !== 0);
  }
}
function AddressFormComponent_div_5_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "ng-select", 38);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const titles_r6 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "addressForm.titleOptional"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("searchable", true)("clearable", false)("items", titles_r6)("placeholder", i0.ɵɵpipeBind1(6, 8, "addressForm.title"))("cxNgSelectA11y", i0.ɵɵpureFunction1(12, _c6, i0.ɵɵpipeBind1(7, 10, "addressForm.title")));
  }
}
function AddressFormComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddressFormComponent_div_5_ng_container_1_div_1_Template, 8, 14, "div", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const titles_r6 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", titles_r6.length !== 0);
  }
}
function AddressFormComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AddressFormComponent_div_5_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.titles$));
  }
}
function AddressFormComponent_ng_template_11_Template(rf, ctx) {}
function AddressFormComponent_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 39);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.firstName.label")))("control", ctx_r2.addressForm.get("firstName"));
  }
}
function AddressFormComponent_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("firstName"));
  }
}
function AddressFormComponent_ng_template_21_Template(rf, ctx) {}
function AddressFormComponent_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 40);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.lastName.label")))("control", ctx_r2.addressForm.get("lastName"));
  }
}
function AddressFormComponent_cx_form_errors_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("lastName"));
  }
}
function AddressFormComponent_ng_template_31_Template(rf, ctx) {}
function AddressFormComponent_cx_form_errors_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 41);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.address1")))("control", ctx_r2.addressForm.get("line1"));
  }
}
function AddressFormComponent_cx_form_errors_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("line1"));
  }
}
function AddressFormComponent_ng_template_49_Template(rf, ctx) {}
function AddressFormComponent_cx_form_errors_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 42);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.city.label")))("control", ctx_r2.addressForm.get("town"));
  }
}
function AddressFormComponent_cx_form_errors_53_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("town"));
  }
}
function AddressFormComponent_ng_template_59_Template(rf, ctx) {}
function AddressFormComponent_cx_form_errors_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 43);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.zipCode.label")))("control", ctx_r2.addressForm.get("postalCode"));
  }
}
function AddressFormComponent_cx_form_errors_63_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("postalCode"));
  }
}
function AddressFormComponent_ng_container_64_ng_container_1_ng_template_6_Template(rf, ctx) {}
function AddressFormComponent_ng_container_64_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 26)(2, "label")(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵtemplate(6, AddressFormComponent_ng_container_64_ng_container_1_ng_template_6_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "ng-select", 45);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelement(10, "cx-form-errors", 37);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    const requiredAsterisk_r5 = i0.ɵɵreference(92);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 11, "addressForm.state"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("bindLabel", regions_r7[0].name ? "name" : "isocode");
    i0.ɵɵpropertyInterpolate("bindValue", regions_r7[0].name ? "isocode" : "region");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 13, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(17, _c8))("searchable", true)("clearable", false)("items", regions_r7)("cxNgSelectA11y", i0.ɵɵpureFunction1(18, _c6, i0.ɵɵpipeBind1(9, 15, "addressForm.state")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("region.isocode"));
  }
}
function AddressFormComponent_ng_container_64_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 44);
    i0.ɵɵtemplate(1, AddressFormComponent_ng_container_64_ng_container_1_Template, 11, 20, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r7 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", regions_r7.length !== 0);
  }
}
function AddressFormComponent_div_81_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 46)(2, "label")(3, "input", 47);
    i0.ɵɵlistener("change", function AddressFormComponent_div_81_Template_input_change_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDefaultAddress());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 48);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "addressForm.setAsDefault"));
  }
}
function AddressFormComponent_div_85_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "button", 49);
    i0.ɵɵlistener("click", function AddressFormComponent_div_85_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.back());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.cancelBtnLabel || i0.ɵɵpipeBind1(3, 1, "addressForm.chooseAddress"), " ");
  }
}
function AddressFormComponent_ng_template_91_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 51);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function AddressFormComponent_ng_template_91_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AddressFormComponent_ng_template_91_abbr_0_Template, 3, 3, "abbr", 50);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function AddressBookComponent_ng_container_1_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function AddressBookComponent_ng_container_1_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "cx-card", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("editCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_editCard_1_listener() {
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.editAddressButtonHandle(address_r4));
    })("setDefaultCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_setDefaultCard_1_listener() {
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setAddressAsDefault(address_r4));
    })("deleteCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_deleteCard_1_listener() {
      let tmp_7_0;
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setEdit((tmp_7_0 = address_r4.id) !== null && tmp_7_0 !== undefined ? tmp_7_0 : ""));
    })("cancelCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_cancelCard_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.cancelCard());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const address_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("index", i_r5)("border", true)("fitToContainer", true)("content", i0.ɵɵpipeBind1(2, 5, ctx_r1.getCardContent(address_r4)))("editMode", address_r4.id === ctx_r1.editCard);
  }
}
function AddressBookComponent_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AddressBookComponent_ng_container_1_div_6_div_1_Template, 2, 3, "div", 8)(2, AddressBookComponent_ng_container_1_div_6_div_2_Template, 3, 7, "div", 9);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.addresses$));
  }
}
function AddressBookComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "button", 5);
    i0.ɵɵlistener("click", function AddressBookComponent_ng_container_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressButtonHandle());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, AddressBookComponent_ng_container_1_div_6_Template, 4, 4, "div", 6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "addressBook.addNewAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(7, 5, ctx_r1.addressesStateLoading$))("ngIfElse", loading_r6);
  }
}
function AddressBookComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section")(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "cx-address-form", 14);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵlistener("submitAddress", function AddressBookComponent_ng_container_3_Template_cx_address_form_submitAddress_5_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressSubmit($event));
    })("backToAddress", function AddressBookComponent_ng_container_3_Template_cx_address_form_backToAddress_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressCancel());
    })("cancelCard", function AddressBookComponent_ng_container_3_Template_cx_address_form_cancelCard_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelCard());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "addressBook.addNewDeliveryAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("actionBtnLabel", i0.ɵɵpipeBind1(6, 8, "addressBook.addAddress"));
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(7, 10, "addressBook.backToAddressList"));
    i0.ɵɵproperty("showTitleCode", true)("showCancelBtn", !(((tmp_6_0 = i0.ɵɵpipeBind1(8, 12, ctx_r1.addresses$)) == null ? null : tmp_6_0.length) === 0))("setAsDefaultField", !(((tmp_7_0 = i0.ɵɵpipeBind1(9, 14, ctx_r1.addresses$)) == null ? null : tmp_7_0.length) === 0));
  }
}
function AddressBookComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section")(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "cx-address-form", 15);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("submitAddress", function AddressBookComponent_ng_container_5_Template_cx_address_form_submitAddress_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editAddressSubmit($event));
    })("backToAddress", function AddressBookComponent_ng_container_5_Template_cx_address_form_backToAddress_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editAddressCancel());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "addressBook.editDeliveryAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("actionBtnLabel", i0.ɵɵpipeBind1(6, 7, "addressBook.updateAddress"));
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(7, 9, "addressBook.backToAddressList"));
    i0.ɵɵproperty("showTitleCode", true)("addressData", ctx_r1.currentAddress);
  }
}
function AddressBookComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function SuggestedAddressDialogComponent_div_1_h3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addressSuggestion.verifyYourAddress"), " ");
  }
}
function SuggestedAddressDialogComponent_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addressSuggestion.verifyYourAddress"), " ");
  }
}
function SuggestedAddressDialogComponent_div_1_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "input", 24);
    i0.ɵɵtwoWayListener("ngModelChange", function SuggestedAddressDialogComponent_div_1_div_16_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAddress, $event) || (ctx_r1.selectedAddress = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 25);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 26)(6, "div", 16)(7, "div", 17);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 17)(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 17);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 17);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 17);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const suggestedAddress_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const data_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAddress);
    i0.ɵɵproperty("value", suggestedAddress_r4)("id", "suggested-addresses--suggested-" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", "suggested-addresses--suggested-" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 13, "addressSuggestion.suggestedAddress"), " ", data_r6.suggestedAddresses.length > 1 ? i_r5 + 1 : null, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.firstName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.lastName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.line1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.line2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.town);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", suggestedAddress_r4 == null ? null : suggestedAddress_r4.region == null ? null : suggestedAddress_r4.region.isocode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", suggestedAddress_r4 == null ? null : suggestedAddress_r4.postalCode, " ");
  }
}
function SuggestedAddressDialogComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, SuggestedAddressDialogComponent_div_1_h3_2_Template, 3, 3, "h3", 4)(3, SuggestedAddressDialogComponent_div_1_div_3_Template, 3, 3, "div", 4);
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal("Cross click"));
    });
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵelement(8, "cx-icon", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵtemplate(16, SuggestedAddressDialogComponent_div_1_div_16_Template, 22, 15, "div", 11);
    i0.ɵɵelementStart(17, "div", 12)(18, "input", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function SuggestedAddressDialogComponent_div_1_Template_input_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAddress, $event) || (ctx_r1.selectedAddress = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "label", 14);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 15)(23, "div", 16)(24, "div", 17);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 17);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 17)(29, "span");
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 17);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 17);
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(35, "div", 18)(36, "div", 19)(37, "div", 20)(38, "button", 21);
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_38_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal("Edit address"));
    });
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "button", 22);
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_41_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal(ctx_r1.selectedAddress));
    });
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "cxTranslate");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const data_r6 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 20, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 22, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(13, 24, "addressSuggestion.ensureAccuracySuggestChange"), " ", i0.ɵɵpipeBind1(14, 26, "addressSuggestion.chooseAddressToUse"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", data_r6.suggestedAddresses);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAddress);
    i0.ɵɵproperty("value", data_r6.enteredAddress);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 28, "addressSuggestion.enteredAddress"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.firstName, " ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.lastName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(data_r6.enteredAddress == null ? null : data_r6.enteredAddress.line1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(data_r6.enteredAddress == null ? null : data_r6.enteredAddress.line2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.town, " ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.region == null ? null : data_r6.enteredAddress.region.isocode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.postalCode, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 30, "addressSuggestion.editAddress"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 32, "addressSuggestion.saveAddress"), " ");
  }
}
function OneTimePasswordRegisterComponent_section_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function OneTimePasswordRegisterComponent_section_0_ng_template_19_Template(rf, ctx) {}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.firstName.label")))("control", ctx_r1.registerForm.get("firstName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("firstName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_ng_template_29_Template(rf, ctx) {}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.lastName.label")))("control", ctx_r1.registerForm.get("lastName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("lastName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_ng_template_39_Template(rf, ctx) {}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.emailAddress.label")))("control", ctx_r1.registerForm.get("email"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("email"));
  }
}
function OneTimePasswordRegisterComponent_section_0_label_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵelement(1, "input", 30);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const anonymousConsent_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isConsentGiven(anonymousConsent_r3.consent));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", anonymousConsent_r3.template, " ");
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "input", 33);
    i0.ɵɵlistener("change", function OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r5 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateAdditionalConsents($event, i_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-form-errors", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const id_r6 = ctx.ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    const control_r8 = ctx_r6.$implicit;
    const i_r5 = ctx_r6.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", consents_r9[i_r5].required)("name", id_r6)("formControlName", i_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consents_r9[i_r5].template.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", control_r8);
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template, 6, 5, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consents_r9[i_r5] == null ? null : consents_r9[i_r5].template == null ? null : consents_r9[i_r5].template.id);
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_48_div_1_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.additionalConsents.controls);
  }
}
function OneTimePasswordRegisterComponent_section_0_ng_template_60_Template(rf, ctx) {}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.termsAndConditions")))("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function OneTimePasswordRegisterComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 3);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_1_Template, 2, 3, "div", 4);
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7)(5, "form", 8);
    i0.ɵɵlistener("ngSubmit", function OneTimePasswordRegisterComponent_section_0_Template_form_ngSubmit_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm());
    });
    i0.ɵɵelementStart(6, "div", 9)(7, "label")(8, "span", 10);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "ng-select", 11);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 9)(15, "label")(16, "span", 10);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵtemplate(19, OneTimePasswordRegisterComponent_section_0_ng_template_19_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 13);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵtemplate(22, OneTimePasswordRegisterComponent_section_0_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 14)(23, OneTimePasswordRegisterComponent_section_0_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 9)(25, "label")(26, "span", 10);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵtemplate(29, OneTimePasswordRegisterComponent_section_0_ng_template_29_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "input", 16);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵtemplate(32, OneTimePasswordRegisterComponent_section_0_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 14)(33, OneTimePasswordRegisterComponent_section_0_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 9)(35, "label")(36, "span", 10);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵtemplate(39, OneTimePasswordRegisterComponent_section_0_ng_template_39_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "input", 17);
    i0.ɵɵpipe(41, "cxTranslate");
    i0.ɵɵtemplate(42, OneTimePasswordRegisterComponent_section_0_cx_form_errors_42_Template, 2, 6, "cx-form-errors", 14)(43, OneTimePasswordRegisterComponent_section_0_cx_form_errors_43_Template, 1, 1, "cx-form-errors", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(44, "div", 9)(45, "div", 18);
    i0.ɵɵtemplate(46, OneTimePasswordRegisterComponent_section_0_label_46_Template, 4, 2, "label", 19);
    i0.ɵɵpipe(47, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(48, OneTimePasswordRegisterComponent_section_0_div_48_Template, 2, 1, "div", 20);
    i0.ɵɵelementStart(49, "div", 9)(50, "div", 18)(51, "label");
    i0.ɵɵelement(52, "input", 21);
    i0.ɵɵelementStart(53, "span", 22);
    i0.ɵɵtext(54);
    i0.ɵɵpipe(55, "cxTranslate");
    i0.ɵɵelementStart(56, "a", 23);
    i0.ɵɵpipe(57, "cxUrl");
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(60, OneTimePasswordRegisterComponent_section_0_ng_template_60_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(61, OneTimePasswordRegisterComponent_section_0_cx_form_errors_61_Template, 2, 6, "cx-form-errors", 14)(62, OneTimePasswordRegisterComponent_section_0_cx_form_errors_62_Template, 1, 1, "cx-form-errors", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(63, "cx-captcha", 24);
    i0.ɵɵlistener("confirmed", function OneTimePasswordRegisterComponent_section_0_Template_cx_captcha_confirmed_63_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.captchaConfirmed());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(64, "cx-form-errors", 25);
    i0.ɵɵelementStart(65, "button", 26);
    i0.ɵɵtext(66);
    i0.ɵɵpipe(67, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "a", 27);
    i0.ɵɵpipe(69, "cxUrl");
    i0.ɵɵtext(70);
    i0.ɵɵpipe(71, "cxTranslate");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const requiredAsterisk_r10 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formGroup", ctx_r1.registerForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 35, "register.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("items", i0.ɵɵpipeBind1(12, 37, ctx_r1.titles$))("placeholder", i0.ɵɵpipeBind1(13, 39, "register.selectTitle"))("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction0(67, _c4));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 41, "register.firstName.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 43, "register.firstName.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(28, 45, "register.lastName.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(31, 47, "register.lastName.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(38, 49, "register.emailAddress.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(41, 51, "register.emailAddress.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(47, 53, ctx_r1.anonymousConsent$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.additionalRegistrationConsents);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(55, 55, "register.confirmThatRead"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(57, 57, i0.ɵɵpureFunction0(68, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(59, 59, "register.termsAndConditions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("captcha"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(67, 61, "register.furtherRegistration"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(69, 63, i0.ɵɵpureFunction0(69, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 65, "register.signIn"));
  }
}
function OneTimePasswordRegisterComponent_ng_template_2_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 35);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function OneTimePasswordRegisterComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OneTimePasswordRegisterComponent_ng_template_2_abbr_0_Template, 3, 3, "abbr", 34);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function OneTimePasswordRegisterComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c9 = ["noReceiveCodeLink"];
const _c10 = ["resendLink"];
const _c11 = () => ({
  cxRoute: "register"
});
const _c12 = a0 => ({
  seconds: a0
});
const _c13 = a0 => ({
  "disabled-link": a0
});
const _c14 = a0 => ({
  waitTime: a0
});
function RegistrationVerificationTokenFormComponent_ng_template_5_Template(rf, ctx) {}
function RegistrationVerificationTokenFormComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "register.rateLimitForRegistrationMessage", i0.ɵɵpureFunction1(4, _c12, ctx_r1.waitTimeForRateLimit)), " ");
  }
}
function RegistrationVerificationTokenFormComponent_div_11_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "verificationTokenForm.sendRateLime", i0.ɵɵpureFunction1(4, _c14, ctx_r1.waitTime)), " ");
  }
}
function RegistrationVerificationTokenFormComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "span", 24)(3, "a", 25, 2);
    i0.ɵɵlistener("keydown.enter", function RegistrationVerificationTokenFormComponent_div_11_Template_a_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("keydown.space", function RegistrationVerificationTokenFormComponent_div_11_Template_a_keydown_space_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("click", function RegistrationVerificationTokenFormComponent_div_11_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, RegistrationVerificationTokenFormComponent_div_11_ng_container_7_Template, 3, 6, "ng-container", 26);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 27)(9, "a", 28, 3);
    i0.ɵɵlistener("keydown", function RegistrationVerificationTokenFormComponent_div_11_Template_a_keydown_9_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOpenInfoDailogKeyDown($event));
    })("click", function RegistrationVerificationTokenFormComponent_div_11_Template_a_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openInfoDailog());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c13, ctx_r1.isResendDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "verificationTokenForm.resend"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isResendDisabled);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 6, "verificationTokenForm.noReceiveCode"), " ");
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_17_Template(rf, ctx) {}
function RegistrationVerificationTokenFormComponent_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.password.label")))("control", ctx_r1.registerForm.get("password"));
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("password"));
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_31_Template(rf, ctx) {}
function RegistrationVerificationTokenFormComponent_cx_form_errors_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.confirmPassword.label")))("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_45_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 31);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationVerificationTokenFormComponent_ng_template_45_abbr_0_Template, 3, 3, "abbr", 30);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
class CloseAccountModalComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.dismissModal('Cross click');
    }
  }
  constructor(authService, globalMessageService, routingService, translationService, userProfile, launchDialogService, el) {
    this.authService = authService;
    this.globalMessageService = globalMessageService;
    this.routingService = routingService;
    this.translationService = translationService;
    this.userProfile = userProfile;
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    this.loading$ = new BehaviorSubject(false);
  }
  get isLoading$() {
    return this.loading$.asObservable();
  }
  ngOnInit() {
    this.isLoggedIn$ = this.authService.isUserLoggedIn();
  }
  onSuccess() {
    this.dismissModal('Success');
    this.translationService.translate('closeAccount.accountClosedSuccessfully').pipe(first()).subscribe(text => {
      this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    });
    this.authService.coreLogout().then(() => {
      this.routingService.go({
        cxRoute: 'home'
      });
    });
  }
  onError() {
    this.dismissModal('Error');
    this.translationService.translate('closeAccount.accountClosedFailure').pipe(first()).subscribe(text => {
      this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
    });
  }
  dismissModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  closeAccount() {
    this.loading$.next(true);
    this.userProfile.close().subscribe({
      next: () => {
        this.onSuccess();
        this.loading$.next(false);
      },
      error: () => {
        this.onError();
        this.loading$.next(false);
      }
    });
  }
  static {
    this.ɵfac = function CloseAccountModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CloseAccountModalComponent)(i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i1.UserProfileFacade), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CloseAccountModalComponent,
      selectors: [["cx-close-account-modal"]],
      hostBindings: function CloseAccountModalComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function CloseAccountModalComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["loaded", ""], [4, "ngIf"], [1, "modal-dialog", "modal-dialog-centered", "cx-close-account-modal", 3, "esc", "cxFocus"], [1, "modal-content", "cx-close-account-modal-container"], [1, "cx-close-account-modal-header", "cx-modal-header"], [1, "cx-close-account-modal-title"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [4, "ngIf", "ngIfElse"], [1, "cx-spinner"], [1, "modal-body"], [1, "cx-confirmation"], [1, "cx-close-account-modal-footer", "cx-modal-footer"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
      template: function CloseAccountModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CloseAccountModalComponent_ng_container_0_Template, 16, 15, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isLoggedIn$));
        }
      },
      dependencies: [i2$1.NgIf, i4.IconComponent, i4.SpinnerComponent, i4.FocusDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloseAccountModalComponent, [{
    type: Component,
    args: [{
      selector: 'cx-close-account-modal',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"isLoggedIn$ | async\">\n  <div\n    class=\"modal-dialog modal-dialog-centered cx-close-account-modal\"\n    [cxFocus]=\"focusConfig\"\n    (esc)=\"dismissModal('Escape click')\"\n  >\n    <div class=\"modal-content cx-close-account-modal-container\">\n      <div class=\"cx-close-account-modal-header cx-modal-header\">\n        <h3 class=\"cx-close-account-modal-title\">\n          {{ 'closeAccount.confirmAccountClosure' | cxTranslate }}\n        </h3>\n        <button\n          type=\"button\"\n          class=\"close\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"dismissModal('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n\n      <div *ngIf=\"isLoading$ | async; else loaded\">\n        <div class=\"cx-spinner\">\n          <cx-spinner> </cx-spinner>\n        </div>\n      </div>\n\n      <ng-template #loaded>\n        <div class=\"modal-body\">\n          <p class=\"cx-confirmation\">\n            {{ 'closeAccount.confirmAccountClosureMessage' | cxTranslate }}\n          </p>\n        </div>\n        <div class=\"cx-close-account-modal-footer cx-modal-footer\">\n          <button class=\"btn btn-primary\" (click)=\"closeAccount()\">\n            {{ 'closeAccount.closeMyAccount' | cxTranslate }}\n          </button>\n          <button\n            (click)=\"dismissModal('Cancel')\"\n            class=\"btn btn-block btn-secondary\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i2.AuthService
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.RoutingService
  }, {
    type: i2.TranslationService
  }, {
    type: i1.UserProfileFacade
  }, {
    type: i4.LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCloseDialogModalLayoutConfig = {
  launch: {
    CLOSE_ACCOUNT: {
      inline: true,
      component: CloseAccountModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CloseAccountComponent {
  constructor(launchDialogService, vcr) {
    this.launchDialogService = launchDialogService;
    this.vcr = vcr;
    this.routingService = inject(RoutingService, {
      optional: true
    });
  }
  openModal() {
    const dialog = this.launchDialogService.openDialog("CLOSE_ACCOUNT" /* LAUNCH_CALLER.CLOSE_ACCOUNT */, this.element, this.vcr);
    dialog?.pipe(take(1)).subscribe();
  }
  navigateTo(cxRoute) {
    this.routingService?.go({
      cxRoute
    });
  }
  static {
    this.ɵfac = function CloseAccountComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CloseAccountComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CloseAccountComponent,
      selectors: [["cx-close-account"]],
      viewQuery: function CloseAccountComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 10,
      vars: 5,
      consts: [["element", ""], [1, "col-lg-8", "col-md-9"], [1, "row", "cx-btn-group"], [1, "col-sm-6"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "click"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
      template: function CloseAccountComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
          i0.ɵɵtemplate(3, CloseAccountComponent_ng_container_3_Template, 4, 3, "ng-container", 4)(4, CloseAccountComponent_ng_container_4_Template, 5, 7, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 3)(6, "button", 5, 0);
          i0.ɵɵlistener("click", function CloseAccountComponent_Template_button_click_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.openModal());
          });
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 3, "closeAccount.closeMyAccount"), " ");
        }
      },
      dependencies: [i5.RouterLink, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloseAccountComponent, [{
    type: Component,
    args: [{
      selector: 'cx-close-account',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"col-lg-8 col-md-9\">\n  <div class=\"row cx-btn-group\">\n    <div class=\"col-sm-6\">\n      <!-- TODO: (CXSPA-7252) - Remove feature flag next major release -->\n      <ng-container *cxFeature=\"'a11yUseButtonsForBtnLinks'\">\n        <button\n          class=\"btn btn-block btn-secondary\"\n          (click)=\"navigateTo('home')\"\n        >\n          {{ 'common.cancel' | cxTranslate }}\n        </button>\n      </ng-container>\n      <ng-container *cxFeature=\"'!a11yUseButtonsForBtnLinks'\">\n        <a\n          [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n          class=\"btn btn-block btn-secondary\"\n          cxBtnLikeLink\n          >{{ 'common.cancel' | cxTranslate }}</a\n        >\n      </ng-container>\n    </div>\n    <div class=\"col-sm-6\">\n      <button #element class=\"btn btn-block btn-primary\" (click)=\"openModal()\">\n        {{ 'closeAccount.closeMyAccount' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i4.LaunchDialogService
  }, {
    type: i0.ViewContainerRef
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }],
    routingService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CloseAccountModule {
  static {
    this.ɵfac = function CloseAccountModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CloseAccountModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CloseAccountModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CloseAccountComponent: {
            component: CloseAccountComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultCloseDialogModalLayoutConfig)],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, IconModule, SpinnerModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloseAccountModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, IconModule, SpinnerModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CloseAccountComponent: {
            component: CloseAccountComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultCloseDialogModalLayoutConfig)],
      declarations: [CloseAccountComponent, CloseAccountModalComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ForgotPasswordComponentService {
  constructor(userPasswordService, routingService, authConfigService, globalMessage) {
    this.userPasswordService = userPasswordService;
    this.routingService = routingService;
    this.authConfigService = authConfigService;
    this.globalMessage = globalMessage;
    this.busy$ = new BehaviorSubject(false);
    this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
    this.form = new UntypedFormGroup({
      userEmail: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator])
    });
  }
  /**
   * Sends an email to the user to reset the password.
   *
   * When the `ResourceOwnerPasswordFlow` is used, the user is routed
   * to the login page.
   */
  requestEmail() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    this.userPasswordService.requestForgotPasswordEmail(this.form.value.userEmail).subscribe({
      next: () => this.onSuccess(),
      error: error => this.onError(error)
    });
  }
  onSuccess() {
    this.globalMessage.add({
      key: 'forgottenPassword.passwordResetEmailSent'
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
    this.form.reset();
    this.redirect();
  }
  onError(_error) {
    this.busy$.next(false);
  }
  /**
   * Redirects the user back to the login page.
   *
   * This only happens in case of the `ResourceOwnerPasswordFlow` OAuth flow.
   */
  redirect() {
    if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
      this.routingService.go({
        cxRoute: 'login'
      });
    }
  }
  static {
    this.ɵfac = function ForgotPasswordComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ForgotPasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.AuthConfigService), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ForgotPasswordComponentService,
      factory: ForgotPasswordComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForgotPasswordComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserPasswordFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.AuthConfigService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ForgotPasswordComponent {
  constructor(service) {
    this.service = service;
    this.routingService = inject(RoutingService, {
      optional: true
    });
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
  }
  onSubmit() {
    this.service.requestEmail();
  }
  navigateTo(cxRoute) {
    this.routingService?.go({
      cxRoute
    });
  }
  static {
    this.ɵfac = function ForgotPasswordComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ForgotPasswordComponent)(i0.ɵɵdirectiveInject(ForgotPasswordComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ForgotPasswordComponent,
      selectors: [["cx-forgot-password"]],
      standalone: false,
      decls: 18,
      vars: 21,
      consts: [["class", "overlay", 4, "ngIf"], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["required", "true", "type", "email", "formControlName", "userEmail", 1, "form-control", 3, "placeholder"], ["id", "userEmailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"], ["id", "userEmailError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
      template: function ForgotPasswordComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ForgotPasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ForgotPasswordComponent_p_2_Template, 3, 3, "p", 1);
          i0.ɵɵelementStart(3, "form", 2);
          i0.ɵɵlistener("ngSubmit", function ForgotPasswordComponent_Template_form_ngSubmit_3_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelementStart(4, "label")(5, "span", 3);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵtemplate(8, ForgotPasswordComponent_abbr_8_Template, 3, 3, "abbr", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 5);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵtemplate(11, ForgotPasswordComponent_cx_form_errors_11_Template, 2, 6, "cx-form-errors", 6)(12, ForgotPasswordComponent_cx_form_errors_12_Template, 1, 1, "cx-form-errors", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, ForgotPasswordComponent_ng_container_13_Template, 4, 3, "ng-container", 8)(14, ForgotPasswordComponent_ng_container_14_Template, 5, 7, "ng-container", 8);
          i0.ɵɵelementStart(15, "button", 9);
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 13, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 15, "forgottenPassword.emailAddress.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 17, "forgottenPassword.emailAddress.placeholder"));
          i0.ɵɵattribute("aria-describedby", "userEmailError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 19, "common.submit"), " ");
        }
      },
      dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i5.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForgotPasswordComponent, [{
    type: Component,
    args: [{
      selector: 'cx-forgot-password',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n<!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n<p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n  {{ 'formLegend.required' | cxTranslate }}\n</p>\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <label>\n    <span class=\"label-content\"\n      >{{ 'forgottenPassword.emailAddress.label' | cxTranslate }}\n      <abbr\n        *cxFeature=\"'a11yRequiredAsterisks'\"\n        aria-hidden=\"true\"\n        class=\"text-decoration-none required-asterisk\"\n        title=\"{{ 'common.required' | cxTranslate }}\"\n        >*</abbr\n      >\n    </span>\n    <input\n      required=\"true\"\n      type=\"email\"\n      class=\"form-control\"\n      placeholder=\"{{\n        'forgottenPassword.emailAddress.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"userEmail\"\n      [attr.aria-describedby]=\"'userEmailError'\"\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"userEmailError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'forgottenPassword.emailAddress.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('userEmail')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('userEmail')\"\n    ></cx-form-errors>\n  </label>\n\n  <!-- TODO: (CXSPA-7252) - Remove feature flag next major release -->\n  <ng-container *cxFeature=\"'a11yUseButtonsForBtnLinks'\">\n    <button class=\"btn btn-block btn-secondary\" (click)=\"navigateTo('login')\">\n      {{ 'common.cancel' | cxTranslate }}\n    </button>\n  </ng-container>\n  <ng-container *cxFeature=\"'!a11yUseButtonsForBtnLinks'\">\n    <a\n      class=\"btn btn-block btn-secondary\"\n      [routerLink]=\"{ cxRoute: 'login' } | cxUrl\"\n      cxBtnLikeLink\n      >{{ 'common.cancel' | cxTranslate }}</a\n    >\n  </ng-container>\n  <button class=\"btn btn-block btn-primary\" [disabled]=\"form.disabled\">\n    {{ 'common.submit' | cxTranslate }}\n  </button>\n</form>\n"
    }]
  }], () => [{
    type: ForgotPasswordComponentService
  }], {
    routingService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ForgotPasswordModule {
  static {
    this.ɵfac = function ForgotPasswordModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ForgotPasswordModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ForgotPasswordModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ForgotPasswordComponent: {
            component: ForgotPasswordComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: ForgotPasswordComponentService,
              useClass: ForgotPasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, AuthConfigService, GlobalMessageService]
            }]
          }
        }
      })],
      imports: [CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForgotPasswordModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ForgotPasswordComponent: {
            component: ForgotPasswordComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: ForgotPasswordComponentService,
              useClass: ForgotPasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, AuthConfigService, GlobalMessageService]
            }]
          }
        }
      })],
      declarations: [ForgotPasswordComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RegisterComponentService {
  constructor(userRegisterFacade, globalMessageService, fb) {
    this.userRegisterFacade = userRegisterFacade;
    this.globalMessageService = globalMessageService;
    this.fb = fb;
    this.featureConfigService = inject(FeatureConfigService);
  }
  /**
   * Register a new user.
   *
   * @param user as UserSignUp
   */
  register(user) {
    return this.userRegisterFacade.register(user);
  }
  /**
   * Returns titles that can be used for the user profiles.
   */
  getTitles() {
    return this.userRegisterFacade.getTitles();
  }
  /**
   * Show the message after successful registration.
   */
  postRegisterMessage() {
    if (this.featureConfigService.isEnabled('a11yPostRegisterSuccessMessage')) {
      this.globalMessageService.add({
        key: 'register.postRegisterSuccessMessage'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    } else {
      this.globalMessageService.add({
        key: 'register.postRegisterMessage'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  /**
   * Get if any additional consents needs to be provided during registration
   * In core feature, no additional consents are necessary during registration.
   * In integration scenarios, eg: cdc, this method will be overridden to return
   * necessary cdc consents
   */
  getAdditionalConsents() {
    return [];
  }
  /**
   * Generate form control if any additional consents that needs to be provided during registration
   * In core feature, no additional consents are necessary during registration.
   * In integration scenarios, eg: cdc, this method will be overridden to return
   * form controls for necessary cdc consents
   */
  generateAdditionalConsentsFormControl() {
    return this.fb?.array([]) ?? undefined;
  }
  static {
    this.ɵfac = function RegisterComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegisterComponentService)(i0.ɵɵinject(i1.UserRegisterFacade), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i3.UntypedFormBuilder));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RegisterComponentService,
      factory: RegisterComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegisterComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserRegisterFacade
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i3.UntypedFormBuilder
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RegisterComponent {
  get additionalConsents() {
    return this.registerForm?.get('additionalConsents');
  }
  updateAdditionalConsents(event, index) {
    const {
      checked
    } = event.target;
    this.registerForm.value.additionalConsents[index] = checked;
  }
  constructor(globalMessageService, fb, router, anonymousConsentsService, anonymousConsentsConfig, authConfigService, registerComponentService) {
    this.globalMessageService = globalMessageService;
    this.fb = fb;
    this.router = router;
    this.anonymousConsentsService = anonymousConsentsService;
    this.anonymousConsentsConfig = anonymousConsentsConfig;
    this.authConfigService = authConfigService;
    this.registerComponentService = registerComponentService;
    // TODO: (CXSPA-7315) Remove feature toggle in the next major
    // TODO: (CXSPA-8550) Remove feature toggle
    this.featureConfigService = inject(FeatureConfigService);
    this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
    this.isLoading$ = new BehaviorSubject(false);
    this.subscription = new Subscription();
    this.registerForm = this.fb.group({
      titleCode: [null],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      password: ['', [Validators.required, ...this.passwordValidators]],
      passwordconf: ['', Validators.required],
      newsletter: new UntypedFormControl({
        value: false,
        disabled: this.isConsentRequired()
      }),
      additionalConsents: this.registerComponentService.generateAdditionalConsentsFormControl?.() ?? this.fb.array([]),
      termsandconditions: [false, Validators.requiredTrue],
      captcha: [false, Validators.requiredTrue]
    }, {
      validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf')
    });
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  ngOnInit() {
    this.titles$ = this.registerComponentService.getTitles().pipe(map(titles => {
      return titles.sort(sortTitles);
    }));
    // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
    this.subscription.add(this.globalMessageService.get().pipe(filter(messages => !!Object.keys(messages).length)).subscribe(globalMessageEntities => {
      const messages = globalMessageEntities && globalMessageEntities[GlobalMessageType.MSG_TYPE_ERROR];
      if (messages && messages.some(message => message.raw === 'This field is required.')) {
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        this.globalMessageService.add({
          key: 'register.titleRequired'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
    }));
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent ?? '';
    this.anonymousConsent$ = combineLatest([this.anonymousConsentsService.getConsent(registerConsent), this.anonymousConsentsService.getTemplate(registerConsent)]).pipe(map(([consent, template]) => {
      return {
        consent,
        template: template?.description ? template.description : ''
      };
    }));
    this.additionalRegistrationConsents = this.registerComponentService?.getAdditionalConsents() || [];
    this.subscription.add(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.registerForm.get('newsletter').valueChanges.subscribe(() => {
      this.toggleAnonymousConsent();
    }));
  }
  submitForm() {
    if (this.registerForm.valid) {
      this.registerUser();
    } else {
      this.registerForm.markAllAsTouched();
    }
  }
  registerUser() {
    this.isLoading$.next(true);
    this.registerComponentService.register(this.collectDataFromRegisterForm(this.registerForm.value)).subscribe({
      next: () => this.onRegisterUserSuccess(),
      complete: () => this.isLoading$.next(false),
      error: () => this.isLoading$.next(false)
    });
  }
  titleSelected(title) {
    this.registerForm['controls'].titleCode.setValue(title.code);
  }
  collectDataFromRegisterForm(formData) {
    const {
      firstName,
      lastName,
      email,
      password,
      titleCode
    } = formData;
    return {
      firstName,
      lastName,
      uid: email.toLowerCase(),
      password,
      titleCode
    };
  }
  isConsentGiven(consent) {
    return this.anonymousConsentsService.isConsentGiven(consent);
  }
  isConsentRequired() {
    const requiredConsents = this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents;
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
    if (requiredConsents && registerConsent) {
      return requiredConsents.includes(registerConsent);
    }
    return false;
  }
  onRegisterUserSuccess() {
    if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
      this.router.go('login');
    }
    this.registerComponentService.postRegisterMessage();
  }
  toggleAnonymousConsent() {
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
    if (registerConsent) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (Boolean(this.registerForm.get('newsletter').value)) {
        this.anonymousConsentsService.giveConsent(registerConsent);
      } else {
        this.anonymousConsentsService.withdrawConsent(registerConsent);
      }
    }
  }
  /**
   * Triggered via CaptchaComponent when a user confirms captcha
   */
  captchaConfirmed() {
    this.registerForm.get('captcha')?.setValue(true);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function RegisterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegisterComponent)(i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i2.AnonymousConsentsService), i0.ɵɵdirectiveInject(i2.AnonymousConsentsConfig), i0.ɵɵdirectiveInject(i2.AuthConfigService), i0.ɵɵdirectiveInject(RegisterComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RegisterComponent,
      selectors: [["cx-register"]],
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [["requiredAsterisk", ""], ["loading", ""], ["class", "cx-page-section container", 4, "ngIf", "ngIfElse"], [1, "cx-page-section", "container"], ["role", "status", 4, "cxFeature"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "cx-section"], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["bindLabel", "name", "bindValue", "code", "formControlName", "titleCode", "id", "title-select", 3, "clearable", "items", "placeholder", "searchable", "cxNgSelectA11y"], [3, "ngTemplateOutlet"], ["required", "true", "type", "text", "name", "firstname", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastname", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "password-input-hint", 1, "input-hint"], [3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "confirmpassword", "formControlName", "passwordconf", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordconfError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "form-check"], [4, "ngIf"], ["formArrayName", "additionalConsents", "class", "form-group", 4, "ngIf"], ["required", "true", "type", "checkbox", "name", "termsandconditions", "formControlName", "termsandconditions"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 3, "routerLink"], ["id", "termsandconditionsError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "confirmed"], [3, "control"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], [1, "cx-login-link", "btn-link", 3, "routerLink"], ["role", "status"], [1, "form-legend"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control"], [3, "translationParams", "control"], ["id", "passwordconfError", "aria-live", "off", 3, "translationParams", "control"], ["type", "checkbox", "name", "newsletter", "formControlName", "newsletter", 1, "form-check-input", 3, "checked"], ["formArrayName", "additionalConsents", 1, "form-group"], ["class", "form-check", 4, "ngFor", "ngForOf"], ["type", "checkbox", 3, "change", "required", "name", "formControlName"], ["id", "termsandconditionsError", "aria-live", "off", 3, "translationParams", "control"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"], [1, "cx-spinner"]],
      template: function RegisterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, RegisterComponent_section_0_Template, 98, 103, "section", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, RegisterComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, RegisterComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r11 = i0.ɵɵreference(5);
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx.isLoading$))("ngIfElse", loading_r11);
        }
      },
      dependencies: [i4.CaptchaComponent, i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.CheckboxRequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormArrayName, i5.RouterLink, i4.SpinnerComponent, i4.FormErrorsComponent, i4.NgSelectA11yDirective, i6.NgSelectComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegisterComponent, [{
    type: Component,
    args: [{
      selector: 'cx-register',
      standalone: false,
      template: "<section\n  class=\"cx-page-section container\"\n  *ngIf=\"!(isLoading$ | async); else loading\"\n>\n  <div\n    *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n    role=\"status\"\n    [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n  ></div>\n  <div class=\"row justify-content-center\">\n    <div class=\"col-md-6\">\n      <div class=\"cx-section\">\n        <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n        <p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n          {{ 'formLegend.required' | cxTranslate }}\n        </p>\n        <form (ngSubmit)=\"submitForm()\" [formGroup]=\"registerForm\">\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\">{{\n                'register.titleOptional' | cxTranslate\n              }}</span>\n              <ng-select\n                [clearable]=\"false\"\n                [items]=\"titles$ | async\"\n                [placeholder]=\"'register.selectTitle' | cxTranslate\"\n                [searchable]=\"false\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                formControlName=\"titleCode\"\n                id=\"title-select\"\n                [cxNgSelectA11y]=\"{}\"\n              >\n              </ng-select>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.firstName.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"text\"\n                name=\"firstname\"\n                placeholder=\"{{\n                  'register.firstName.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"firstName\"\n                [attr.aria-describedby]=\"'firstNameError'\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                id=\"firstNameError\"\n                aria-live=\"off\"\n                [translationParams]=\"{\n                  label: 'register.firstName.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('firstName')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('firstName')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.lastName.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"text\"\n                name=\"lastname\"\n                placeholder=\"{{\n                  'register.lastName.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"lastName\"\n                [attr.aria-describedby]=\"'lastNameError'\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                id=\"lastNameError\"\n                aria-live=\"off\"\n                [translationParams]=\"{\n                  label: 'register.lastName.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('lastName')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('lastName')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.emailAddress.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"email\"\n                name=\"email\"\n                placeholder=\"{{\n                  'register.emailAddress.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"email\"\n                [attr.aria-describedby]=\"'emailError'\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                id=\"emailError\"\n                aria-live=\"off\"\n                [translationParams]=\"{\n                  label: 'register.emailAddress.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('email')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('email')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.password.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"password\"\n                name=\"password\"\n                placeholder=\"{{\n                  'register.password.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"password\"\n                [attr.aria-label]=\"\n                  'register.password.placeholder' | cxTranslate\n                \"\n                aria-describedby=\"password-input-hint\"\n                cxPasswordVisibilitySwitch\n              />\n              <p class=\"input-hint\" id=\"password-input-hint\">\n                {{ 'register.passwordMinRequirements' | cxTranslate }}\n              </p>\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                [translationParams]=\"{\n                  label: 'register.password.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('password')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('password')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.confirmPassword.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"password\"\n                name=\"confirmpassword\"\n                placeholder=\"{{\n                  'register.confirmPassword.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"passwordconf\"\n                [attr.aria-label]=\"\n                  'register.confirmPassword.placeholder' | cxTranslate\n                \"\n                [attr.aria-describedby]=\"'passwordconfError'\"\n                cxPasswordVisibilitySwitch\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                id=\"passwordconfError\"\n                aria-live=\"off\"\n                [translationParams]=\"{\n                  label: 'register.confirmPassword.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('passwordconf')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('passwordconf')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"form-check\">\n              <label *ngIf=\"anonymousConsent$ | async as anonymousConsent\">\n                <input\n                  type=\"checkbox\"\n                  name=\"newsletter\"\n                  class=\"form-check-input\"\n                  formControlName=\"newsletter\"\n                  [checked]=\"isConsentGiven(anonymousConsent.consent)\"\n                />\n                <span class=\"form-check-label\">\n                  {{ anonymousConsent.template }}\n                </span>\n              </label>\n            </div>\n          </div>\n\n          <div\n            formArrayName=\"additionalConsents\"\n            class=\"form-group\"\n            *ngIf=\"additionalRegistrationConsents as consents\"\n          >\n            <div\n              class=\"form-check\"\n              *ngFor=\"let control of additionalConsents.controls; let i = index\"\n            >\n              <div *ngIf=\"consents[i]?.template?.id as id\">\n                <label>\n                  <input\n                    type=\"checkbox\"\n                    [required]=\"consents[i].required\"\n                    [name]=\"id\"\n                    (change)=\"updateAdditionalConsents($any($event), i)\"\n                    [formControlName]=\"i\"\n                  />\n                  <span class=\"form-check-label\">\n                    {{ consents[i].template.description }}\n                  </span>\n                  <cx-form-errors [control]=\"control\"></cx-form-errors>\n                </label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"form-check\">\n              <label>\n                <input\n                  required=\"true\"\n                  type=\"checkbox\"\n                  name=\"termsandconditions\"\n                  formControlName=\"termsandconditions\"\n                  [attr.aria-describedby]=\"'termsandconditionsError'\"\n                />\n                <span class=\"form-check-label\">\n                  {{ 'register.confirmThatRead' | cxTranslate }}\n                  <a\n                    [routerLink]=\"{ cxRoute: 'termsAndConditions' } | cxUrl\"\n                    target=\"_blank\"\n                    rel=\"noopener noreferrer\"\n                  >\n                    {{ 'register.termsAndConditions' | cxTranslate }}\n                  </a>\n                  <ng-template\n                    [ngTemplateOutlet]=\"requiredAsterisk\"\n                  ></ng-template>\n                </span>\n\n                <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n                <cx-form-errors\n                  *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                  id=\"termsandconditionsError\"\n                  aria-live=\"off\"\n                  [translationParams]=\"{\n                    label: 'register.termsAndConditions' | cxTranslate,\n                  }\"\n                  [control]=\"registerForm.get('termsandconditions')\"\n                ></cx-form-errors>\n\n                <cx-form-errors\n                  *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                  [control]=\"registerForm.get('termsandconditions')\"\n                ></cx-form-errors>\n              </label>\n            </div>\n          </div>\n          <cx-captcha (confirmed)=\"captchaConfirmed()\"></cx-captcha>\n          <cx-form-errors\n            [control]=\"registerForm.get('captcha')\"\n          ></cx-form-errors>\n          <button type=\"submit\" class=\"btn btn-block btn-primary\">\n            {{ 'register.register' | cxTranslate }}\n          </button>\n          <a\n            class=\"cx-login-link btn-link\"\n            [routerLink]=\"{ cxRoute: 'login' } | cxUrl\"\n            >{{ 'register.signIn' | cxTranslate }}</a\n          >\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i2.GlobalMessageService
  }, {
    type: i3.UntypedFormBuilder
  }, {
    type: i2.RoutingService
  }, {
    type: i2.AnonymousConsentsService
  }, {
    type: i2.AnonymousConsentsConfig
  }, {
    type: i2.AuthConfigService
  }, {
    type: RegisterComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RegisterComponentModule {
  static {
    this.ɵfac = function RegisterComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegisterComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RegisterComponentModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          RegisterCustomerComponent: {
            component: RegisterComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegisterComponentService,
              useClass: RegisterComponentService,
              deps: [UserRegisterFacade, GlobalMessageService, UntypedFormBuilder]
            }]
          }
        }
      })],
      imports: [CaptchaModule, CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, SpinnerModule, FormErrorsModule, NgSelectA11yModule, NgSelectModule, PasswordVisibilityToggleModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegisterComponentModule, [{
    type: NgModule,
    args: [{
      imports: [CaptchaModule, CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, SpinnerModule, FormErrorsModule, NgSelectA11yModule, NgSelectModule, PasswordVisibilityToggleModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          RegisterCustomerComponent: {
            component: RegisterComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegisterComponentService,
              useClass: RegisterComponentService,
              deps: [UserRegisterFacade, GlobalMessageService, UntypedFormBuilder]
            }]
          }
        }
      })],
      declarations: [RegisterComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ResetPasswordComponentService {
  constructor(userPasswordService, routingService, globalMessage) {
    this.userPasswordService = userPasswordService;
    this.routingService = routingService;
    this.globalMessage = globalMessage;
    // TODO: (CXSPA-7315) Remove feature toggle in the next major
    // TODO: (CXSPA-8550) Remove feature toggle
    this.featureConfigService = inject(FeatureConfigService);
    this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
    this.busy$ = new BehaviorSubject(false);
    this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
    this.resetToken$ = this.routingService.getRouterState().pipe(map(routerState => routerState.state.queryParams['token']));
    this.form = new UntypedFormGroup({
      password: new UntypedFormControl('', [Validators.required, ...this.passwordValidators]),
      passwordConfirm: new UntypedFormControl('', Validators.required)
    }, {
      validators: CustomFormValidators.passwordsMustMatch('password', 'passwordConfirm')
    });
  }
  /**
   * Resets the password by the given token.
   *
   * The token has been provided during the request password flow.
   * The token is not validated on the client.
   */
  resetPassword(token) {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    const password = this.form.get('password').value;
    this.userPasswordService.reset(token, password).subscribe({
      next: () => this.onSuccess(),
      error: error => this.onError(error)
    });
  }
  onSuccess() {
    this.globalMessage.add({
      key: 'forgottenPassword.passwordResetSuccess'
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
    this.form.reset();
    this.redirect();
  }
  onError(error) {
    this.busy$.next(false);
    if (error instanceof HttpErrorModel) {
      (error.details ?? []).forEach(err => {
        if (err.message) {
          this.globalMessage.add({
            raw: err.message
          }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      });
    }
  }
  /**
   * Redirects the user to the login page.
   */
  redirect() {
    this.routingService.go({
      cxRoute: 'login'
    });
  }
  static {
    this.ɵfac = function ResetPasswordComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetPasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ResetPasswordComponentService,
      factory: ResetPasswordComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserPasswordFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ResetPasswordComponent {
  constructor(service) {
    this.service = service;
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    this.token$ = this.service.resetToken$;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit(token) {
    this.service.resetPassword(token);
  }
  static {
    this.ɵfac = function ResetPasswordComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetPasswordComponent)(i0.ɵɵdirectiveInject(ResetPasswordComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ResetPasswordComponent,
      selectors: [["cx-reset-password"]],
      hostAttrs: [1, "user-form"],
      standalone: false,
      decls: 6,
      vars: 6,
      consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], [3, "formGroup", "ngSubmit", 4, "ngIf"], [1, "overlay"], [3, "ngSubmit", "formGroup"], ["class", "form-legend", 4, "cxFeature"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "formControlName", "passwordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordConfirmError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "form-legend"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "passwordConfirmError", "aria-live", "off", 3, "translationParams", "control"], ["class", "text-decoration-none required-asterisk", "aria-hidden", "true", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function ResetPasswordComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ResetPasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ResetPasswordComponent_form_2_Template, 25, 32, "form", 2);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵtemplate(4, ResetPasswordComponent_ng_template_4_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.token$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordComponent, [{
    type: Component,
    args: [{
      selector: 'cx-reset-password',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'user-form'
      },
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n\n<form\n  *ngIf=\"token$ | async as token\"\n  (ngSubmit)=\"onSubmit(token)\"\n  [formGroup]=\"form\"\n>\n  <p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n    {{ 'formLegend.required' | cxTranslate }}\n  </p>\n  <label>\n    <span class=\"label-content\"\n      >{{ 'register.newPassword' | cxTranslate\n      }}<ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      type=\"password\"\n      placeholder=\"{{ 'register.password.placeholder' | cxTranslate }}\"\n      formControlName=\"password\"\n      [attr.aria-label]=\"'register.password.placeholder' | cxTranslate\"\n      [attr.aria-describedby]=\"'passwordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"passwordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'register.newPassword' | cxTranslate,\n      }\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'register.passwordMinRequirements' | cxTranslate\n      }}<ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      type=\"password\"\n      placeholder=\"{{ 'register.confirmPassword.placeholder' | cxTranslate }}\"\n      formControlName=\"passwordConfirm\"\n      [attr.aria-label]=\"'register.confirmPassword.placeholder' | cxTranslate\"\n      [attr.aria-describedby]=\"'passwordConfirmError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"passwordConfirmError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'register.passwordMinRequirements' | cxTranslate,\n      }\"\n      [control]=\"form.get('passwordConfirm')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('passwordConfirm')\"\n    ></cx-form-errors>\n  </label>\n\n  <button class=\"btn btn-block btn-primary\" [disabled]=\"form.disabled\">\n    {{ 'register.resetPassword' | cxTranslate }}\n  </button>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    class=\"text-decoration-none required-asterisk\"\n    aria-hidden=\"true\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: ResetPasswordComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ResetPasswordModule {
  static {
    this.ɵfac = function ResetPasswordModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetPasswordModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ResetPasswordModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ResetPasswordComponent: {
            component: ResetPasswordComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: ResetPasswordComponentService,
              useClass: ResetPasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, GlobalMessageService]
            }]
          }
        }
      })],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ResetPasswordComponent: {
            component: ResetPasswordComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: ResetPasswordComponentService,
              useClass: ResetPasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, GlobalMessageService]
            }]
          }
        }
      })],
      declarations: [ResetPasswordComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdateEmailComponentService {
  constructor(userEmail, routingService, globalMessageService, authService, authRedirectService) {
    this.userEmail = userEmail;
    this.routingService = routingService;
    this.globalMessageService = globalMessageService;
    this.authService = authService;
    this.authRedirectService = authRedirectService;
    this.busy$ = new BehaviorSubject(false);
    this.updateSucceed$ = new Subject();
    this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
      confirmEmail: new UntypedFormControl('', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required])
    }, {
      validators: CustomFormValidators.emailsMustMatch('email', 'confirmEmail')
    });
  }
  save() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    const newEmail = this.form.get('confirmEmail')?.value;
    const password = this.form.get('password')?.value;
    this.userEmail.update(password, newEmail).subscribe({
      next: () => this.onSuccess(newEmail),
      error: error => this.onError(error)
    });
  }
  /**
   * Handles successful updating of the user email.
   */
  onSuccess(newUid) {
    this.globalMessageService.add({
      key: 'updateEmailForm.emailUpdateSuccess',
      params: {
        newUid
      }
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
    this.form.reset();
    this.updateSucceed$.next(true);
    // sets the redirect url after login
    this.authRedirectService.setRedirectUrl(this.routingService.getUrl({
      cxRoute: 'home'
    }));
    // TODO(#9638): Use logout route when it will support passing redirect url
    this.authService.coreLogout().then(() => {
      this.routingService.go({
        cxRoute: 'login'
      }, {
        state: {
          newUid
        }
      });
    });
  }
  onError(_error) {
    this.busy$.next(false);
    this.updateSucceed$.next(false);
  }
  static {
    this.ɵfac = function UpdateEmailComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateEmailComponentService)(i0.ɵɵinject(i1.UserEmailFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i2.AuthRedirectService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdateEmailComponentService,
      factory: UpdateEmailComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateEmailComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserEmailFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.AuthService
  }, {
    type: i2.AuthRedirectService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdateEmailComponent {
  constructor(service) {
    this.service = service;
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit() {
    this.service.save();
  }
  static {
    this.ɵfac = function UpdateEmailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateEmailComponent)(i0.ɵɵdirectiveInject(UpdateEmailComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UpdateEmailComponent,
      selectors: [["cx-update-email"]],
      hostAttrs: [1, "user-form"],
      standalone: false,
      decls: 41,
      vars: 49,
      consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "confirmEmail", "formControlName", "confirmEmail", 1, "form-control", 3, "placeholder"], ["id", "confirmEmailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "autocomplete", "new-password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "confirmEmailError", "aria-live", "off", 3, "translationParams", "control"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function UpdateEmailComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, UpdateEmailComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, UpdateEmailComponent_p_2_Template, 3, 3, "p", 2);
          i0.ɵɵelementStart(3, "form", 3);
          i0.ɵɵlistener("ngSubmit", function UpdateEmailComponent_Template_form_ngSubmit_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSubmit());
          });
          i0.ɵɵelementStart(4, "label")(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵtemplate(8, UpdateEmailComponent_ng_template_8_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 6);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵtemplate(11, UpdateEmailComponent_cx_form_errors_11_Template, 2, 6, "cx-form-errors", 7)(12, UpdateEmailComponent_cx_form_errors_12_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "label")(14, "span", 4);
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵtemplate(17, UpdateEmailComponent_ng_template_17_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(18, "input", 9);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵtemplate(20, UpdateEmailComponent_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 10)(21, UpdateEmailComponent_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "label")(23, "span", 4);
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "cxTranslate");
          i0.ɵɵtemplate(26, UpdateEmailComponent_ng_template_26_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(27, "input", 11);
          i0.ɵɵpipe(28, "cxTranslate");
          i0.ɵɵpipe(29, "cxTranslate");
          i0.ɵɵtemplate(30, UpdateEmailComponent_cx_form_errors_30_Template, 2, 6, "cx-form-errors", 12)(31, UpdateEmailComponent_cx_form_errors_31_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(32, "a", 13);
          i0.ɵɵpipe(33, "cxUrl");
          i0.ɵɵtext(34);
          i0.ɵɵpipe(35, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(36, "button", 14);
          i0.ɵɵtext(37);
          i0.ɵɵpipe(38, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(39, UpdateEmailComponent_ng_template_39_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const requiredAsterisk_r3 = i0.ɵɵreference(40);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 26, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 28, "updateEmailForm.newEmailAddress.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 30, "updateEmailForm.newEmailAddress.placeholder"));
          i0.ɵɵattribute("aria-describedby", "emailError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(16, 32, "updateEmailForm.confirmNewEmailAddress.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 34, "updateEmailForm.confirmNewEmailAddress.placeholder"));
          i0.ɵɵattribute("aria-describedby", "confirmEmailError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 36, "updateEmailForm.password.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(28, 38, "updateEmailForm.password.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(29, 40, "updateEmailForm.password.placeholder"))("aria-describedby", "passwordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(33, 42, i0.ɵɵpureFunction0(48, _c1)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 44, "common.cancel"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 46, "common.save"), " ");
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i5.RouterLink, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateEmailComponent, [{
    type: Component,
    args: [{
      selector: 'cx-update-email',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'user-form'
      },
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n<!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n<p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n  {{ 'formLegend.required' | cxTranslate }}\n</p>\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updateEmailForm.newEmailAddress.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      type=\"email\"\n      name=\"email\"\n      formControlName=\"email\"\n      placeholder=\"{{\n        'updateEmailForm.newEmailAddress.placeholder' | cxTranslate\n      }}\"\n      [attr.aria-describedby]=\"'emailError'\"\n      class=\"form-control\"\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"emailError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateEmailForm.newEmailAddress.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('email')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('email')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updateEmailForm.confirmNewEmailAddress.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      type=\"email\"\n      name=\"confirmEmail\"\n      formControlName=\"confirmEmail\"\n      placeholder=\"{{\n        'updateEmailForm.confirmNewEmailAddress.placeholder' | cxTranslate\n      }}\"\n      [attr.aria-describedby]=\"'confirmEmailError'\"\n      class=\"form-control\"\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"confirmEmailError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateEmailForm.confirmNewEmailAddress.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('confirmEmail')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('confirmEmail')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updateEmailForm.password.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      type=\"password\"\n      name=\"password\"\n      formControlName=\"password\"\n      placeholder=\"{{ 'updateEmailForm.password.placeholder' | cxTranslate }}\"\n      class=\"form-control\"\n      autocomplete=\"new-password\"\n      [attr.aria-label]=\"'updateEmailForm.password.placeholder' | cxTranslate\"\n      [attr.aria-describedby]=\"'passwordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"passwordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateEmailForm.password.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n  </label>\n\n  <a\n    class=\"btn btn-block btn-secondary\"\n    [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n    cxBtnLikeLink\n  >\n    {{ 'common.cancel' | cxTranslate }}\n  </a>\n\n  <button class=\"btn btn-block btn-primary\" [disabled]=\"form.disabled\">\n    {{ 'common.save' | cxTranslate }}\n  </button>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: UpdateEmailComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2EmailComponent {
  constructor() {
    this.emailComponentService = inject(UpdateEmailComponentService);
    this.userProfile = inject(UserProfileFacade);
    this.form = this.emailComponentService.form;
    this.isUpdating$ = this.emailComponentService.isUpdating$;
    this.user$ = this.userProfile.get().pipe(filter(user => Boolean(user)));
    this.globalMessageType = GlobalMessageType;
  }
  ngOnInit() {
    this.isEditing = false;
  }
  onSubmit() {
    this.emailComponentService.save();
    this.emailComponentService.updateSucceed$.subscribe(res => {
      this.isEditing = !res;
    });
  }
  onEdit() {
    this.isEditing = true;
    this.showingAlert = true;
    this.form.reset();
  }
  cancelEdit() {
    this.isEditing = false;
  }
  closeDialogConfirmationAlert() {
    this.showingAlert = false;
  }
  static {
    this.ɵfac = function MyAccountV2EmailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2EmailComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2EmailComponent,
      selectors: [["cx-my-account-v2-email"]],
      standalone: false,
      decls: 13,
      vars: 12,
      consts: [["class", "overlay", 4, "ngIf$", "ngIf"], [1, "flex-line"], [1, "headertext"], ["class", "editButton", 3, "click", 4, "ngIf"], [4, "ngIf"], [3, "text", "type", "closeMessage", 4, "ngIf"], ["class", "email-editing-area", 4, "ngIf"], [1, "overlay"], [1, "editButton", 3, "click"], [1, "text-head"], [1, "value"], [3, "closeMessage", "text", "type"], [1, "email-editing-area"], [3, "ngSubmit", "formGroup"], ["type", "text", "readonly", "", 1, "form-control", 3, "value"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "confirmEmail", "formControlName", "confirmEmail", 1, "form-control", 3, "placeholder"], ["id", "confirmEmailError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "label-content,", "text-head"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "autocomplete", "new-password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn-group"], [1, "btn", "button-cancel", "button", 3, "click"], [1, "btn", "btn-primary", "button", 3, "click", "disabled"], ["id", "emailError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "confirmEmailError", "aria-live", "off", 3, "translationParams", "control"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control"]],
      template: function MyAccountV2EmailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2EmailComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementStart(3, "div")(4, "div", 1)(5, "label", 2);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, MyAccountV2EmailComponent_button_8_Template, 3, 3, "button", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div");
          i0.ɵɵtemplate(10, MyAccountV2EmailComponent_div_10_Template, 8, 6, "div", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, MyAccountV2EmailComponent_cx_message_11_Template, 2, 4, "cx-message", 5)(12, MyAccountV2EmailComponent_div_12_Template, 40, 44, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 6, ctx.isUpdating$) || !i0.ɵɵpipeBind1(2, 8, ctx.user$));
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 10, "myAccountV2Email.myEmailAddress"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.isEditing);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.isEditing);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEditing && ctx.showingAlert);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEditing);
        }
      },
      dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.MessageComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2EmailComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-email',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner\n  class=\"overlay\"\n  *ngIf=\"(isUpdating$ | async) || !(user$ | async); $\"\n>\n</cx-spinner>\n<div>\n  <div class=\"flex-line\">\n    <label class=\"headertext\"\n      >{{ 'myAccountV2Email.myEmailAddress' | cxTranslate }}\n    </label>\n    <button class=\"editButton\" *ngIf=\"!isEditing\" (click)=\"onEdit()\">\n      {{ 'common.edit' | cxTranslate }}\n    </button>\n  </div>\n  <div>\n    <div *ngIf=\"!isEditing\">\n      <div class=\"flex-line\">\n        <label class=\"text-head\">\n          {{ 'myAccountV2Email.email' | cxTranslate }}\n        </label>\n        <label class=\"value\">\n          {{ (user$ | async)?.uid }}\n        </label>\n      </div>\n    </div>\n  </div>\n  <cx-message\n    *ngIf=\"isEditing && showingAlert\"\n    [text]=\"'myAccountV2Email.reloginIndicator' | cxTranslate\"\n    [type]=\"globalMessageType.MSG_TYPE_INFO\"\n    (closeMessage)=\"closeDialogConfirmationAlert()\"\n  ></cx-message>\n  <div *ngIf=\"isEditing\" class=\"email-editing-area\">\n    <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n      <label>\n        <span class=\"text-head\">{{\n          'myAccountV2Email.emailAddress' | cxTranslate\n        }}</span>\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          [value]=\"(user$ | async)?.uid\"\n          readonly\n        />\n      </label>\n\n      <label>\n        <span class=\"text-head\">{{\n          'myAccountV2Email.newEmailAddress' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"email\"\n          name=\"email\"\n          formControlName=\"email\"\n          placeholder=\"{{ 'myAccountV2Email.emailPlaceHolder' | cxTranslate }}\"\n          class=\"form-control\"\n          [attr.aria-describedby]=\"'emailError'\"\n        />\n\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"emailError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateEmailForm.newEmailAddress.label' | cxTranslate,\n          }\"\n          [control]=\"form.get('email')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('email')\"\n        ></cx-form-errors>\n      </label>\n\n      <label>\n        <span class=\"text-head\">{{\n          'myAccountV2Email.confirmNewEmailAddress' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"email\"\n          name=\"confirmEmail\"\n          formControlName=\"confirmEmail\"\n          placeholder=\"{{ 'myAccountV2Email.emailPlaceHolder' | cxTranslate }}\"\n          class=\"form-control\"\n          [attr.aria-describedby]=\"'confirmEmailError'\"\n        />\n\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"confirmEmailError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateEmailForm.confirmNewEmailAddress.label' | cxTranslate,\n          }\"\n          [control]=\"form.get('confirmEmail')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('confirmEmail')\"\n        ></cx-form-errors>\n      </label>\n\n      <label>\n        <span class=\"label-content, text-head\">{{\n          'myAccountV2Email.password' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"password\"\n          name=\"password\"\n          formControlName=\"password\"\n          placeholder=\"{{\n            'myAccountV2Email.passwordPlaceHolder' | cxTranslate\n          }}\"\n          class=\"form-control\"\n          autocomplete=\"new-password\"\n          [attr.aria-label]=\"\n            'myAccountV2Email.passwordPlaceHolder' | cxTranslate\n          \"\n          [attr.aria-describedby]=\"'passwordError'\"\n          cxPasswordVisibilitySwitch\n        />\n\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"passwordError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateEmailForm.password.label' | cxTranslate,\n          }\"\n          [control]=\"form.get('password')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('password')\"\n        ></cx-form-errors>\n      </label>\n\n      <div class=\"btn-group\">\n        <button class=\"btn button-cancel button\" (click)=\"cancelEdit()\">\n          {{ 'common.cancel' | cxTranslate }}\n        </button>\n        <button\n          class=\"btn btn-primary button\"\n          (click)=\"onSubmit()\"\n          [disabled]=\"form.disabled\"\n        >\n          {{ 'common.save' | cxTranslate }}\n        </button>\n      </div>\n    </form>\n  </div>\n</div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_EMAIL = new InjectionToken('feature flag to enable enhanced UI for email related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2EmailMapping = {
  cmsComponents: {
    UpdateEmailComponent: {
      component: MyAccountV2EmailComponent
    }
  }
};
class UpdateEmailModule {
  static {
    this.ɵfac = function UpdateEmailModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateEmailModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UpdateEmailModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdateEmailComponent: {
            component: UpdateEmailComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdateEmailComponentService,
              useClass: UpdateEmailComponentService,
              deps: [UserEmailFacade, RoutingService, GlobalMessageService, AuthService, AuthRedirectService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_EMAIL) ? myAccountV2EmailMapping : {})],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, UrlModule, RouterModule, I18nModule, FormErrorsModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateEmailModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, UrlModule, RouterModule, I18nModule, FormErrorsModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule],
      declarations: [UpdateEmailComponent, MyAccountV2EmailComponent],
      exports: [UpdateEmailComponent, MyAccountV2EmailComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdateEmailComponent: {
            component: UpdateEmailComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdateEmailComponentService,
              useClass: UpdateEmailComponentService,
              deps: [UserEmailFacade, RoutingService, GlobalMessageService, AuthService, AuthRedirectService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_EMAIL) ? myAccountV2EmailMapping : {})]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_PASSWORD = new InjectionToken('feature flag to enable enhanced UI for Update Password related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdatePasswordComponentService {
  constructor(userPasswordService, routingService, globalMessageService, authRedirectService, authService) {
    this.userPasswordService = userPasswordService;
    this.routingService = routingService;
    this.globalMessageService = globalMessageService;
    this.authRedirectService = authRedirectService;
    this.authService = authService;
    // TODO: (CXSPA-7315) Remove feature toggle in the next major
    // TODO: (CXSPA-8550) Remove feature toggle
    this.featureConfigService = inject(FeatureConfigService);
    this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
    this.busy$ = new BehaviorSubject(false);
    this.usingV2 = inject(USE_MY_ACCOUNT_V2_PASSWORD);
    this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
    this.form = new UntypedFormGroup({
      oldPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [Validators.required, ...this.passwordValidators]),
      newPasswordConfirm: new UntypedFormControl('', Validators.required)
    }, {
      validators: this.getPasswordValidators()
    });
  }
  /**
   * Updates the password for the user.
   */
  updatePassword() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    const oldPassword = this.form.get('oldPassword')?.value;
    const newPassword = this.form.get('newPassword')?.value;
    this.userPasswordService.update(oldPassword, newPassword).subscribe({
      next: () => this.onSuccess(),
      error: error => this.onError(error)
    });
  }
  onSuccess() {
    this.globalMessageService.add({
      key: this.usingV2 ? 'myAccountV2PasswordForm.passwordUpdateSuccess' : 'updatePasswordForm.passwordUpdateSuccess'
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
    this.form.reset();
    // sets the redirect url after login
    this.authRedirectService?.setRedirectUrl(this.routingService.getUrl({
      cxRoute: 'home'
    }));
    // TODO(#9638): Use logout route when it will support passing redirect url
    this.authService?.coreLogout().then(() => {
      this.routingService.go({
        cxRoute: 'login'
      });
    });
  }
  onError(_error) {
    if (_error instanceof HttpErrorModel && _error.details?.[0].type === 'AccessDeniedError') {
      this.globalMessageService.add({
        key: this.usingV2 ? 'myAccountV2PasswordForm.accessDeniedError' : 'updatePasswordForm.accessDeniedError'
      }, GlobalMessageType.MSG_TYPE_ERROR);
    }
    this.busy$.next(false);
    this.form.reset();
  }
  // TODO: (CXSPA-8550) Remove after removing enablePasswordsCannotMatchInPasswordUpdateForm feature toggle
  getPasswordValidators() {
    const passwordMustMatchValidator = CustomFormValidators.passwordsMustMatch('newPassword', 'newPasswordConfirm');
    return this.featureConfigService.isEnabled('enablePasswordsCannotMatchInPasswordUpdateForm') ? [passwordMustMatchValidator, CustomFormValidators.passwordsCannotMatch('oldPassword', 'newPassword')] : [passwordMustMatchValidator];
  }
  static {
    this.ɵfac = function UpdatePasswordComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdatePasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i2.AuthRedirectService), i0.ɵɵinject(i2.AuthService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdatePasswordComponentService,
      factory: UpdatePasswordComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdatePasswordComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserPasswordFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.AuthRedirectService
  }, {
    type: i2.AuthService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdatePasswordComponent {
  constructor(service) {
    this.service = service;
    this.routingService = inject(RoutingService, {
      optional: true
    });
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit() {
    this.service.updatePassword();
  }
  navigateTo(cxRoute) {
    this.routingService?.go({
      cxRoute
    });
  }
  static {
    this.ɵfac = function UpdatePasswordComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdatePasswordComponent)(i0.ɵɵdirectiveInject(UpdatePasswordComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UpdatePasswordComponent,
      selectors: [["cx-update-password"]],
      hostAttrs: [1, "user-form"],
      standalone: false,
      decls: 41,
      vars: 50,
      consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "type", "password", "name", "oldPassword", "formControlName", "oldPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "oldPasswordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPassword", "formControlName", "newPassword", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "newPasswordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPasswordConfirm", "formControlName", "newPasswordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "newPasswordConfirmError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], ["id", "oldPasswordError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "newPasswordError", "aria-live", "off", 3, "translationParams", "control"], ["id", "newPasswordConfirmError", "aria-live", "off", 3, "translationParams", "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function UpdatePasswordComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, UpdatePasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, UpdatePasswordComponent_p_2_Template, 3, 3, "p", 2);
          i0.ɵɵelementStart(3, "form", 3);
          i0.ɵɵlistener("ngSubmit", function UpdatePasswordComponent_Template_form_ngSubmit_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSubmit());
          });
          i0.ɵɵelementStart(4, "label")(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵtemplate(8, UpdatePasswordComponent_ng_template_8_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 6);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵpipe(11, "cxTranslate");
          i0.ɵɵtemplate(12, UpdatePasswordComponent_cx_form_errors_12_Template, 2, 6, "cx-form-errors", 7)(13, UpdatePasswordComponent_cx_form_errors_13_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "label")(15, "span", 4);
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵtemplate(18, UpdatePasswordComponent_ng_template_18_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(19, "input", 9);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵtemplate(22, UpdatePasswordComponent_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 10)(23, UpdatePasswordComponent_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(24, "label")(25, "span", 4);
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "cxTranslate");
          i0.ɵɵtemplate(28, UpdatePasswordComponent_ng_template_28_Template, 0, 0, "ng-template", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(29, "input", 11);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵpipe(31, "cxTranslate");
          i0.ɵɵtemplate(32, UpdatePasswordComponent_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 12)(33, UpdatePasswordComponent_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(34, UpdatePasswordComponent_ng_container_34_Template, 4, 3, "ng-container", 13)(35, UpdatePasswordComponent_ng_container_35_Template, 5, 7, "ng-container", 13);
          i0.ɵɵelementStart(36, "button", 14);
          i0.ɵɵtext(37);
          i0.ɵɵpipe(38, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(39, UpdatePasswordComponent_ng_template_39_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const requiredAsterisk_r4 = i0.ɵɵreference(40);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 28, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 30, "updatePasswordForm.oldPassword.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 32, "updatePasswordForm.oldPassword.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(11, 34, "updatePasswordForm.oldPassword.placeholder"))("aria-describedby", "oldPasswordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(17, 36, "updatePasswordForm.newPassword.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(20, 38, "updatePasswordForm.newPassword.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(21, 40, "updatePasswordForm.newPassword.placeholder"))("aria-describedby", "newPasswordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(27, 42, "updatePasswordForm.confirmPassword.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 44, "updatePasswordForm.confirmPassword.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(31, 46, "updatePasswordForm.confirmPassword.placeholder"))("aria-describedby", "newPasswordConfirmError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 48, "common.save"), " ");
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i5.RouterLink, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdatePasswordComponent, [{
    type: Component,
    args: [{
      selector: 'cx-update-password',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'user-form'
      },
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n<!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n<p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n  {{ 'formLegend.required' | cxTranslate }}\n</p>\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updatePasswordForm.oldPassword.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      type=\"password\"\n      name=\"oldPassword\"\n      placeholder=\"{{\n        'updatePasswordForm.oldPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"oldPassword\"\n      [attr.aria-label]=\"\n        'updatePasswordForm.oldPassword.placeholder' | cxTranslate\n      \"\n      [attr.aria-describedby]=\"'oldPasswordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"oldPasswordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.oldPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('oldPassword')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('oldPassword')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updatePasswordForm.newPassword.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      type=\"password\"\n      name=\"newPassword\"\n      placeholder=\"{{\n        'updatePasswordForm.newPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"newPassword\"\n      [attr.aria-label]=\"\n        'updatePasswordForm.newPassword.placeholder' | cxTranslate\n      \"\n      [attr.aria-describedby]=\"'newPasswordError'\"\n      aria-describedby=\"password-input-hint\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"newPasswordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.newPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('newPassword')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('newPassword')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updatePasswordForm.confirmPassword.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      type=\"password\"\n      name=\"newPasswordConfirm\"\n      placeholder=\"{{\n        'updatePasswordForm.confirmPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"newPasswordConfirm\"\n      [attr.aria-label]=\"\n        'updatePasswordForm.confirmPassword.placeholder' | cxTranslate\n      \"\n      [attr.aria-describedby]=\"'newPasswordConfirmError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"newPasswordConfirmError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.confirmPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('newPasswordConfirm')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('newPasswordConfirm')\"\n    ></cx-form-errors>\n  </label>\n\n  <!-- TODO: (CXSPA-7252) - Remove feature flag next major release -->\n  <ng-container *cxFeature=\"'a11yUseButtonsForBtnLinks'\">\n    <button class=\"btn btn-block btn-secondary\" (click)=\"navigateTo('home')\">\n      {{ 'common.cancel' | cxTranslate }}\n    </button>\n  </ng-container>\n  <ng-container *cxFeature=\"'!a11yUseButtonsForBtnLinks'\">\n    <a\n      [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n      class=\"btn btn-block btn-secondary\"\n      cxBtnLikeLink\n      >{{ 'common.cancel' | cxTranslate }}</a\n    >\n  </ng-container>\n\n  <button class=\"btn btn-block btn-primary\" [disabled]=\"form.disabled\">\n    {{ 'common.save' | cxTranslate }}\n  </button>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: UpdatePasswordComponentService
  }], {
    routingService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2PasswordComponent {
  constructor() {
    this.service = inject(UpdatePasswordComponentService);
    this.showingAlert = true;
    this.globalMessageType = GlobalMessageType;
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit() {
    this.service.updatePassword();
  }
  onCancel() {
    this.oldPassword = '';
    this.newPassword = '';
    this.newPasswordConfirm = '';
  }
  closeDialogConfirmationAlert() {
    this.showingAlert = false;
  }
  static {
    this.ɵfac = function MyAccountV2PasswordComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2PasswordComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2PasswordComponent,
      selectors: [["cx-my-account-v2-password"]],
      standalone: false,
      decls: 41,
      vars: 53,
      consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "myaccount-password-header"], [3, "text", "type", "closeMessage", 4, "ngIf"], [1, "myaccount-label-padding"], [1, "label-content", "myaccount-password-label"], ["required", "true", "type", "password", "name", "oldPassword", "formControlName", "oldPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], ["id", "oldPasswordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPassword", "formControlName", "newPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], ["id", "newPasswordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPasswordConfirm", "formControlName", "newPasswordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], [3, "translationParams", "control", 4, "cxFeature"], [1, "password-btn-group"], [1, "btn", "myaccount-password-button", "myaccount-password-button-cancel", 3, "click"], [1, "btn", "btn-primary", "myaccount-password-button", 3, "disabled"], [1, "overlay"], [3, "closeMessage", "text", "type"], ["id", "oldPasswordError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "newPasswordError", "aria-live", "off", 3, "translationParams", "control"], [3, "translationParams", "control"]],
      template: function MyAccountV2PasswordComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2PasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵelementStart(2, "form", 1);
          i0.ɵɵlistener("ngSubmit", function MyAccountV2PasswordComponent_Template_form_ngSubmit_2_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelementStart(3, "label", 2);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, MyAccountV2PasswordComponent_cx_message_6_Template, 2, 4, "cx-message", 3);
          i0.ɵɵelementStart(7, "label", 4)(8, "span", 5);
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "input", 6);
          i0.ɵɵpipe(12, "cxTranslate");
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_11_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.oldPassword, $event) || (ctx.oldPassword = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(14, MyAccountV2PasswordComponent_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 7)(15, MyAccountV2PasswordComponent_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "label", 4)(17, "span", 5);
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(20, "input", 9);
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵpipe(22, "cxTranslate");
          i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_20_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.newPassword, $event) || (ctx.newPassword = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(23, MyAccountV2PasswordComponent_cx_form_errors_23_Template, 2, 6, "cx-form-errors", 10)(24, MyAccountV2PasswordComponent_cx_form_errors_24_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(25, "label", 4)(26, "span", 5);
          i0.ɵɵtext(27);
          i0.ɵɵpipe(28, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(29, "input", 11);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵpipe(31, "cxTranslate");
          i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_29_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.newPasswordConfirm, $event) || (ctx.newPasswordConfirm = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(32, MyAccountV2PasswordComponent_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 12)(33, MyAccountV2PasswordComponent_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(34, "div", 13)(35, "button", 14);
          i0.ɵɵlistener("click", function MyAccountV2PasswordComponent_Template_button_click_35_listener() {
            return ctx.onCancel();
          });
          i0.ɵɵtext(36);
          i0.ɵɵpipe(37, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(38, "button", 15);
          i0.ɵɵtext(39);
          i0.ɵɵpipe(40, "cxTranslate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 27, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 29, "myAccountV2PasswordForm.newPasswordTitle"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showingAlert);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 31, "myAccountV2PasswordForm.oldPassword.label"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 33, "myAccountV2PasswordForm.oldPassword.placeholder"));
          i0.ɵɵtwoWayProperty("ngModel", ctx.oldPassword);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 35, "myAccountV2PasswordForm.oldPassword.placeholder"))("aria-describedby", "oldPasswordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 37, "myAccountV2PasswordForm.newPassword.label"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 39, "myAccountV2PasswordForm.newPassword.placeholder"));
          i0.ɵɵtwoWayProperty("ngModel", ctx.newPassword);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(22, 41, "myAccountV2PasswordForm.newPassword.placeholder"))("aria-describedby", "newPasswordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 43, "myAccountV2PasswordForm.confirmPassword.label"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 45, "myAccountV2PasswordForm.confirmPassword.placeholder"));
          i0.ɵɵtwoWayProperty("ngModel", ctx.newPasswordConfirm);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(31, 47, "myAccountV2PasswordForm.confirmPassword.placeholder"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(37, 49, "common.cancel"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 51, "common.save"), " ");
        }
      },
      dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.MessageComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2PasswordComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-password',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <label class=\"myaccount-password-header\"\n    >{{ 'myAccountV2PasswordForm.newPasswordTitle' | cxTranslate }}\n  </label>\n\n  <cx-message\n    *ngIf=\"showingAlert\"\n    [text]=\"'myAccountV2PasswordForm.reloginIndicator' | cxTranslate\"\n    [type]=\"globalMessageType.MSG_TYPE_INFO\"\n    (closeMessage)=\"closeDialogConfirmationAlert()\"\n  >\n  </cx-message>\n\n  <label class=\"myaccount-label-padding\">\n    <span class=\"label-content myaccount-password-label\">{{\n      'myAccountV2PasswordForm.oldPassword.label' | cxTranslate\n    }}</span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      [(ngModel)]=\"oldPassword\"\n      type=\"password\"\n      name=\"oldPassword\"\n      placeholder=\"{{\n        'myAccountV2PasswordForm.oldPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"oldPassword\"\n      [attr.aria-label]=\"\n        'myAccountV2PasswordForm.oldPassword.placeholder' | cxTranslate\n      \"\n      [attr.aria-describedby]=\"'oldPasswordError'\"\n      cxPasswordVisibilitySwitch\n    />\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"oldPasswordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.oldPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('oldPassword')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('oldPassword')\"\n    ></cx-form-errors>\n  </label>\n\n  <label class=\"myaccount-label-padding\">\n    <span class=\"label-content myaccount-password-label\">{{\n      'myAccountV2PasswordForm.newPassword.label' | cxTranslate\n    }}</span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      [(ngModel)]=\"newPassword\"\n      type=\"password\"\n      name=\"newPassword\"\n      placeholder=\"{{\n        'myAccountV2PasswordForm.newPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"newPassword\"\n      [attr.aria-label]=\"\n        'myAccountV2PasswordForm.newPassword.placeholder' | cxTranslate\n      \"\n      [attr.aria-describedby]=\"'newPasswordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"newPasswordError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.newPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('newPassword')\"\n    ></cx-form-errors>\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('newPassword')\"\n    ></cx-form-errors>\n  </label>\n\n  <label class=\"myaccount-label-padding\">\n    <span class=\"label-content myaccount-password-label\">{{\n      'myAccountV2PasswordForm.confirmPassword.label' | cxTranslate\n    }}</span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      [(ngModel)]=\"newPasswordConfirm\"\n      type=\"password\"\n      name=\"newPasswordConfirm\"\n      placeholder=\"{{\n        'myAccountV2PasswordForm.confirmPassword.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"newPasswordConfirm\"\n      [attr.aria-label]=\"\n        'myAccountV2PasswordForm.confirmPassword.placeholder' | cxTranslate\n      \"\n      cxPasswordVisibilitySwitch\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      [translationParams]=\"{\n        label: 'updatePasswordForm.confirmPassword.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('newPasswordConfirm')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('newPasswordConfirm')\"\n    ></cx-form-errors>\n  </label>\n\n  <div class=\"password-btn-group\">\n    <button\n      class=\"btn myaccount-password-button myaccount-password-button-cancel\"\n      (click)=\"onCancel()\"\n    >\n      {{ 'common.cancel' | cxTranslate }}\n    </button>\n    <button\n      class=\"btn btn-primary myaccount-password-button\"\n      [disabled]=\"form.disabled\"\n    >\n      {{ 'common.save' | cxTranslate }}\n    </button>\n  </div>\n</form>\n"
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2PasswordMapping = {
  cmsComponents: {
    UpdatePasswordComponent: {
      component: MyAccountV2PasswordComponent
    }
  }
};
class UpdatePasswordModule {
  static {
    this.ɵfac = function UpdatePasswordModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdatePasswordModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UpdatePasswordModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdatePasswordComponent: {
            component: UpdatePasswordComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdatePasswordComponentService,
              useClass: UpdatePasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, GlobalMessageService, AuthRedirectService, AuthService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PASSWORD) ? myAccountV2PasswordMapping : {})],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, UrlModule, RouterModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdatePasswordModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, UrlModule, RouterModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdatePasswordComponent: {
            component: UpdatePasswordComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdatePasswordComponentService,
              useClass: UpdatePasswordComponentService,
              deps: [UserPasswordFacade, RoutingService, GlobalMessageService, AuthRedirectService, AuthService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PASSWORD) ? myAccountV2PasswordMapping : {})],
      declarations: [UpdatePasswordComponent, MyAccountV2PasswordComponent],
      exports: [UpdatePasswordComponent, MyAccountV2PasswordComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdateProfileComponentService {
  constructor(userProfile, globalMessageService) {
    this.userProfile = userProfile;
    this.globalMessageService = globalMessageService;
    this.user$ = this.userProfile.get().pipe(filter(user => Boolean(user)));
    this.busy$ = new BehaviorSubject(false);
    this.updateSucceed$ = new Subject();
    this.isUpdating$ = this.user$.pipe(tap(user => this.form.patchValue(user)), switchMap(_user => this.busy$), tap(state => state === true ? this.form.disable() : this.form.enable()));
    this.titles$ = this.userProfile.getTitles();
    this.form = new UntypedFormGroup({
      customerId: new UntypedFormControl(''),
      titleCode: new UntypedFormControl(''),
      firstName: new UntypedFormControl('', Validators.required),
      lastName: new UntypedFormControl('', Validators.required)
    });
  }
  /**
   * Updates the user's details and handles the UI.
   */
  updateProfile() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    this.userProfile.update(this.form.value).subscribe({
      next: () => this.onSuccess(),
      error: error => this.onError(error)
    });
  }
  onSuccess() {
    this.globalMessageService.add({
      key: 'updateProfileForm.profileUpdateSuccess'
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
    this.form.reset();
    this.updateSucceed$.next(true);
  }
  onError(_error) {
    this.busy$.next(false);
    this.updateSucceed$.next(false);
  }
  static {
    this.ɵfac = function UpdateProfileComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateProfileComponentService)(i0.ɵɵinject(i1.UserProfileFacade), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdateProfileComponentService,
      factory: UpdateProfileComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateProfileComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.UserProfileFacade
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UpdateProfileComponent {
  constructor(service) {
    this.service = service;
    this.routingService = inject(RoutingService, {
      optional: true
    });
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    this.titles$ = this.service.titles$;
  }
  onSubmit() {
    this.service.updateProfile();
  }
  navigateTo(cxRoute) {
    this.routingService?.go({
      cxRoute
    });
  }
  static {
    this.ɵfac = function UpdateProfileComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateProfileComponent)(i0.ɵɵdirectiveInject(UpdateProfileComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UpdateProfileComponent,
      selectors: [["cx-update-profile"]],
      hostAttrs: [1, "user-form"],
      standalone: false,
      decls: 44,
      vars: 50,
      consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["formControlName", "titleCode", "id", "title-select", 3, "clearable", "searchable", "cxNgSelectA11y"], [3, "value", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], ["required", "true", "type", "text", "name", "firstName", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastName", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "customerId", "formControlName", "customerId", "readonly", "", 1, "form-control"], ["id", "customerIdError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], [3, "value"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "customerIdError", "aria-live", "off", 3, "translationParams", "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function UpdateProfileComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, UpdateProfileComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, UpdateProfileComponent_p_2_Template, 3, 3, "p", 2);
          i0.ɵɵelementStart(3, "form", 3);
          i0.ɵɵlistener("ngSubmit", function UpdateProfileComponent_Template_form_ngSubmit_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSubmit());
          });
          i0.ɵɵelementStart(4, "label")(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "ng-select", 5);
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵtemplate(10, UpdateProfileComponent_ng_option_10_Template, 2, 2, "ng-option", 6);
          i0.ɵɵpipe(11, "async");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(12, "label")(13, "span", 4);
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "cxTranslate");
          i0.ɵɵtemplate(16, UpdateProfileComponent_ng_template_16_Template, 0, 0, "ng-template", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(17, "input", 8);
          i0.ɵɵpipe(18, "cxTranslate");
          i0.ɵɵtemplate(19, UpdateProfileComponent_cx_form_errors_19_Template, 2, 6, "cx-form-errors", 9)(20, UpdateProfileComponent_cx_form_errors_20_Template, 1, 1, "cx-form-errors", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(21, "label")(22, "span", 4);
          i0.ɵɵtext(23);
          i0.ɵɵpipe(24, "cxTranslate");
          i0.ɵɵtemplate(25, UpdateProfileComponent_ng_template_25_Template, 0, 0, "ng-template", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(26, "input", 11);
          i0.ɵɵpipe(27, "cxTranslate");
          i0.ɵɵtemplate(28, UpdateProfileComponent_cx_form_errors_28_Template, 2, 6, "cx-form-errors", 12)(29, UpdateProfileComponent_cx_form_errors_29_Template, 1, 1, "cx-form-errors", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(30, "label")(31, "span", 4);
          i0.ɵɵtext(32);
          i0.ɵɵpipe(33, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(34, "input", 13);
          i0.ɵɵtemplate(35, UpdateProfileComponent_cx_form_errors_35_Template, 2, 6, "cx-form-errors", 14)(36, UpdateProfileComponent_cx_form_errors_36_Template, 1, 1, "cx-form-errors", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(37, UpdateProfileComponent_ng_container_37_Template, 4, 3, "ng-container", 15)(38, UpdateProfileComponent_ng_container_38_Template, 5, 7, "ng-container", 15);
          i0.ɵɵelementStart(39, "button", 16);
          i0.ɵɵtext(40);
          i0.ɵɵpipe(41, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(42, UpdateProfileComponent_ng_template_42_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const requiredAsterisk_r5 = i0.ɵɵreference(43);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 28, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 30, "updateProfileForm.title"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("clearable", false)("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction1(48, _c6, i0.ɵɵpipeBind1(9, 32, "updateProfileForm.title")));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(11, 34, ctx.titles$));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(15, 36, "updateProfileForm.firstName.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 38, "updateProfileForm.firstName.placeholder"));
          i0.ɵɵattribute("aria-describedby", "firstNameError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(24, 40, "updateProfileForm.lastName.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(27, 42, "updateProfileForm.lastName.placeholder"));
          i0.ɵɵattribute("aria-describedby", "lastNameError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 44, "updateProfileForm.customerId"));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-describedby", "customerIdError");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 46, "common.save"), " ");
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i5.RouterLink, i6.NgSelectComponent, i6.NgOptionComponent, i4.NgSelectA11yDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateProfileComponent, [{
    type: Component,
    args: [{
      selector: 'cx-update-profile',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'user-form'
      },
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"> </cx-spinner>\n<!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n<p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n  {{ 'formLegend.required' | cxTranslate }}\n</p>\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <label>\n    <span class=\"label-content\">{{\n      'updateProfileForm.title' | cxTranslate\n    }}</span>\n    <ng-select\n      [clearable]=\"false\"\n      [searchable]=\"false\"\n      formControlName=\"titleCode\"\n      id=\"title-select\"\n      [cxNgSelectA11y]=\"{\n        ariaLabel: 'updateProfileForm.title' | cxTranslate,\n      }\"\n    >\n      <ng-option *ngFor=\"let title of titles$ | async\" [value]=\"title.code\">{{\n        title.name\n      }}</ng-option>\n    </ng-select>\n  </label>\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updateProfileForm.firstName.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      type=\"text\"\n      class=\"form-control\"\n      name=\"firstName\"\n      placeholder=\"{{\n        'updateProfileForm.firstName.placeholder' | cxTranslate\n      }}\"\n      formControlName=\"firstName\"\n      [attr.aria-describedby]=\"'firstNameError'\"\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"firstNameError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateProfileForm.firstName.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('firstName')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('firstName')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\"\n      >{{ 'updateProfileForm.lastName.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      type=\"text\"\n      class=\"form-control\"\n      name=\"lastName\"\n      placeholder=\"{{ 'updateProfileForm.lastName.placeholder' | cxTranslate }}\"\n      formControlName=\"lastName\"\n      [attr.aria-describedby]=\"'lastNameError'\"\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"lastNameError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateProfileForm.lastName.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('lastName')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('lastName')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\">{{\n      'updateProfileForm.customerId' | cxTranslate\n    }}</span>\n    <input\n      required=\"true\"\n      type=\"text\"\n      class=\"form-control\"\n      name=\"customerId\"\n      formControlName=\"customerId\"\n      [attr.aria-describedby]=\"'customerIdError'\"\n      readonly\n    />\n\n    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n    <cx-form-errors\n      *cxFeature=\"'formErrorsDescriptiveMessages'\"\n      id=\"customerIdError\"\n      aria-live=\"off\"\n      [translationParams]=\"{\n        label: 'updateProfileForm.customerId' | cxTranslate,\n      }\"\n      [control]=\"form.get('customerId')\"\n    ></cx-form-errors>\n\n    <cx-form-errors\n      *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n      [control]=\"form.get('customerId')\"\n    ></cx-form-errors>\n  </label>\n\n  <!-- TODO: (CXSPA-7252) - Remove feature flag next major release -->\n  <ng-container *cxFeature=\"'a11yUseButtonsForBtnLinks'\">\n    <button class=\"btn btn-block btn-secondary\" (click)=\"navigateTo('home')\">\n      {{ 'common.cancel' | cxTranslate }}\n    </button>\n  </ng-container>\n  <ng-container *cxFeature=\"'!a11yUseButtonsForBtnLinks'\">\n    <a\n      [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n      class=\"btn btn-block btn-secondary\"\n      cxBtnLikeLink\n      >{{ 'common.cancel' | cxTranslate }}</a\n    >\n  </ng-container>\n\n  <button class=\"btn btn-block btn-primary\" [disabled]=\"form.disabled\">\n    {{ 'common.save' | cxTranslate }}\n  </button>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: UpdateProfileComponentService
  }], {
    routingService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ProfileComponent {
  constructor() {
    this.service = inject(UpdateProfileComponentService);
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    this.titles$ = this.service.titles$;
    this.user$ = this.service.user$;
  }
  ngOnInit() {
    this.isEditing = false;
  }
  onSubmit() {
    this.service.updateProfile();
    this.service.updateSucceed$.subscribe(res => {
      this.isEditing = !res;
    });
  }
  cancelEdit() {
    this.isEditing = false;
    this.form.setValue(this.originalEditValue);
  }
  onEdit() {
    this.isEditing = true;
    this.originalEditValue = this.form.value;
  }
  static {
    this.ɵfac = function MyAccountV2ProfileComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2ProfileComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2ProfileComponent,
      selectors: [["cx-my-account-v2-profile"]],
      standalone: false,
      decls: 12,
      vars: 11,
      consts: [["class", "overlay", 4, "ngIf"], [1, "flex-line"], [1, "headertext"], ["class", "editButton", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "myaccount-editing-area", 4, "ngIf"], [1, "overlay"], [1, "editButton", 3, "click"], [1, "text-head"], [1, "value"], [1, "myaccount-editing-area"], [3, "ngSubmit", "formGroup"], [1, "label-content,", "text-head"], ["formControlName", "titleCode", "id", "title-select", 3, "clearable", "searchable", "cxNgSelectA11y"], [3, "value", 4, "ngFor", "ngForOf"], ["required", "true", "type", "text", "name", "firstName", "formControlName", "firstName", 1, "form-control"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastName", "formControlName", "lastName", 1, "form-control"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "customerId", "formControlName", "customerId", "readonly", "", 1, "form-control"], ["id", "customerIdError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn-group"], [1, "btn", "button-cancel", "button", 3, "click"], [1, "btn", "btn-primary", "button", 3, "click", "disabled"], [3, "value"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "customerIdError", "aria-live", "off", 3, "translationParams", "control"]],
      template: function MyAccountV2ProfileComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2ProfileComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementStart(3, "div")(4, "div")(5, "div", 1)(6, "label", 2);
          i0.ɵɵtext(7);
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, MyAccountV2ProfileComponent_button_9_Template, 3, 3, "button", 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, MyAccountV2ProfileComponent_div_10_Template, 23, 21, "div", 4)(11, MyAccountV2ProfileComponent_div_11_Template, 38, 39, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 5, ctx.isUpdating$) || !i0.ɵɵpipeBind1(2, 7, ctx.user$));
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 9, "myAccountV2UserProfile.myInformation"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.isEditing);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isEditing);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEditing);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i6.NgSelectComponent, i6.NgOptionComponent, i4.NgSelectA11yDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ProfileComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-profile',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"(isUpdating$ | async) || !(user$ | async)\">\n</cx-spinner>\n<div>\n  <div>\n    <div class=\"flex-line\">\n      <label class=\"headertext\"\n        >{{ 'myAccountV2UserProfile.myInformation' | cxTranslate }}\n      </label>\n      <button class=\"editButton\" *ngIf=\"!isEditing\" (click)=\"onEdit()\">\n        {{ 'common.edit' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n  <div *ngIf=\"!isEditing\">\n    <div class=\"flex-line\">\n      <label class=\"text-head\">\n        {{ 'myAccountV2UserProfile.title' | cxTranslate }}\n      </label>\n      <label class=\"value\">\n        {{ (user$ | async)?.title }}\n      </label>\n    </div>\n    <div class=\"flex-line\">\n      <label class=\"text-head\">\n        {{ 'myAccountV2UserProfile.name' | cxTranslate }}\n      </label>\n      <label class=\"value\">\n        {{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }}\n      </label>\n    </div>\n    <div class=\"flex-line\">\n      <label class=\"text-head\">\n        {{ 'myAccountV2UserProfile.customerId' | cxTranslate }}\n      </label>\n      <label class=\"value\">\n        {{ (user$ | async)?.customerId }}\n      </label>\n    </div>\n  </div>\n  <div *ngIf=\"isEditing\" class=\"myaccount-editing-area\">\n    <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n      <label>\n        <span class=\"label-content, text-head\">{{\n          'myAccountV2UserProfile.title' | cxTranslate\n        }}</span>\n        <ng-select\n          [clearable]=\"false\"\n          [searchable]=\"false\"\n          formControlName=\"titleCode\"\n          id=\"title-select\"\n          [cxNgSelectA11y]=\"{\n            ariaLabel: 'myAccountV2UserProfile.title' | cxTranslate,\n          }\"\n        >\n          <ng-option\n            *ngFor=\"let title of titles$ | async\"\n            [value]=\"title.code\"\n            >{{ title.name }}</ng-option\n          >\n        </ng-select>\n      </label>\n      <label>\n        <span class=\"label-content, text-head\">{{\n          'myAccountV2UserProfile.firstName' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"text\"\n          class=\"form-control\"\n          name=\"firstName\"\n          formControlName=\"firstName\"\n          [attr.aria-describedby]=\"'firstNameError'\"\n        />\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"firstNameError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateProfileForm.firstName.label' | cxTranslate,\n          }\"\n          [control]=\"form.get('firstName')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('firstName')\"\n        ></cx-form-errors>\n      </label>\n\n      <label>\n        <span class=\"label-content, text-head\">{{\n          'myAccountV2UserProfile.lastName' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"text\"\n          class=\"form-control\"\n          name=\"lastName\"\n          formControlName=\"lastName\"\n          [attr.aria-describedby]=\"'lastNameError'\"\n        />\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"lastNameError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateProfileForm.lastName.label' | cxTranslate,\n          }\"\n          [control]=\"form.get('lastName')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('lastName')\"\n        ></cx-form-errors>\n      </label>\n\n      <label>\n        <span class=\"label-content, text-head\">{{\n          'myAccountV2UserProfile.customerId' | cxTranslate\n        }}</span>\n        <input\n          required=\"true\"\n          type=\"text\"\n          class=\"form-control\"\n          name=\"customerId\"\n          formControlName=\"customerId\"\n          [attr.aria-describedby]=\"'customerIdError'\"\n          readonly\n        />\n        <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"customerIdError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'updateProfileForm.customerId' | cxTranslate,\n          }\"\n          [control]=\"form.get('customerId')\"\n        ></cx-form-errors>\n\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"form.get('customerId')\"\n        ></cx-form-errors>\n      </label>\n    </form>\n\n    <div class=\"btn-group\">\n      <button class=\"btn button-cancel button\" (click)=\"cancelEdit()\">\n        {{ 'common.cancel' | cxTranslate }}\n      </button>\n      <button\n        class=\"btn btn-primary button\"\n        (click)=\"onSubmit()\"\n        [disabled]=\"form.disabled\"\n      >\n        {{ 'common.save' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_PROFILE = new InjectionToken('feature flag to enable enhanced UI for profile related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2ProfileMapping = {
  cmsComponents: {
    UpdateProfileComponent: {
      component: MyAccountV2ProfileComponent
    }
  }
};
class UpdateProfileModule {
  static {
    this.ɵfac = function UpdateProfileModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateProfileModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UpdateProfileModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdateProfileComponent: {
            component: UpdateProfileComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdateProfileComponentService,
              useClass: UpdateProfileComponentService,
              deps: [UserProfileFacade, GlobalMessageService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PROFILE) ? myAccountV2ProfileMapping : {})],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, RouterModule, UrlModule, NgSelectModule, NgSelectA11yModule, FeaturesConfigModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateProfileModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, RouterModule, UrlModule, NgSelectModule, NgSelectA11yModule, FeaturesConfigModule, BtnLikeLinkModule],
      declarations: [UpdateProfileComponent, MyAccountV2ProfileComponent],
      exports: [UpdateProfileComponent, MyAccountV2ProfileComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          UpdateProfileComponent: {
            component: UpdateProfileComponent,
            guards: [AuthGuard],
            providers: [{
              provide: UpdateProfileComponentService,
              useClass: UpdateProfileComponentService,
              deps: [UserProfileFacade, GlobalMessageService]
            }]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PROFILE) ? myAccountV2ProfileMapping : {})]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddressBookComponentService {
  constructor(userAddressService) {
    this.userAddressService = userAddressService;
  }
  getAddresses() {
    return this.userAddressService.getAddresses();
  }
  getAddressesStateLoading() {
    return this.userAddressService.getAddressesLoading();
  }
  loadAddresses() {
    this.userAddressService.loadAddresses();
  }
  addUserAddress(address) {
    this.userAddressService.addUserAddress(address);
  }
  updateUserAddress(addressId, address) {
    this.userAddressService.updateUserAddress(addressId, address);
  }
  setAddressAsDefault(addressId) {
    this.userAddressService.setAddressAsDefault(addressId);
  }
  deleteUserAddress(addressId) {
    this.userAddressService.deleteUserAddress(addressId);
  }
  static {
    this.ɵfac = function AddressBookComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressBookComponentService)(i0.ɵɵinject(i2.UserAddressService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddressBookComponentService,
      factory: AddressBookComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressBookComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.UserAddressService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddressFormComponent {
  constructor(fb, userAddressService, globalMessageService, translation, launchDialogService, userProfileFacade) {
    this.fb = fb;
    this.userAddressService = userAddressService;
    this.globalMessageService = globalMessageService;
    this.translation = translation;
    this.launchDialogService = launchDialogService;
    this.userProfileFacade = userProfileFacade;
    this.selectedCountry$ = new BehaviorSubject('');
    this.setAsDefaultField = true;
    this.showCancelBtn = true;
    this.submitAddress = new EventEmitter();
    this.backToAddress = new EventEmitter();
    this.subscription = new Subscription();
    this.addressForm = this.fb.group({
      country: this.fb.group({
        isocode: [null, Validators.required]
      }),
      titleCode: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      line1: ['', Validators.required],
      line2: [''],
      town: ['', Validators.required],
      region: this.fb.group({
        isocode: [null, Validators.required]
      }),
      postalCode: ['', Validators.required],
      phone: '',
      cellphone: '',
      defaultAddress: [false]
    });
  }
  ngOnInit() {
    // Fetching countries if no data stream was provided
    this.countries$ = this.countries || this.userAddressService.getDeliveryCountries().pipe(tap(countries => {
      if (Object.keys(countries).length === 0) {
        this.userAddressService.loadDeliveryCountries();
      }
    }));
    // Fetching titles
    this.titles$ = this.getTitles();
    // Fetching regions
    this.regions$ = this.selectedCountry$.pipe(switchMap(country => this.userAddressService.getRegions(country)), tap(regions => {
      const regionControl = this.addressForm.get('region.isocode');
      if (regions && regions.length > 0) {
        regionControl?.enable();
      } else {
        regionControl?.disable();
      }
    }));
    if (this.addressData && Object.keys(this.addressData).length !== 0) {
      this.addressForm.patchValue(this.addressData);
      this.countrySelected(this.addressData.country);
      if (this.addressData.region) {
        this.regionSelected(this.addressData.region);
      }
    }
    this.addresses$ = this.userAddressService.getAddresses();
  }
  getTitles() {
    return combineLatest([this.translation.translate('addressForm.defaultTitle'), this.userProfileFacade.getTitles()]).pipe(map(([noneTitleText, titles]) => {
      const noneTitle = {
        code: '',
        name: noneTitleText
      };
      titles.sort(sortTitles);
      return [noneTitle, ...titles];
    }));
  }
  handleAddressVerificationResults(results) {
    if (results.decision === 'ACCEPT') {
      this.submitAddress.emit(this.addressForm.value);
    } else if (results.decision === 'REJECT') {
      // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
      if (results.errors?.errors.some(error => error.subject === 'titleCode')) {
        this.globalMessageService.add({
          key: 'addressForm.titleRequired'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      } else {
        this.globalMessageService.add({
          key: 'addressForm.invalidAddress'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
    } else if (results.decision === 'REVIEW') {
      this.openSuggestedAddress(results);
    }
  }
  countrySelected(country) {
    this.addressForm.get('country')?.get('isocode')?.setValue(country?.isocode);
    this.selectedCountry$.next(country?.isocode ?? '');
  }
  regionSelected(region) {
    this.addressForm.get('region')?.get('isocode')?.setValue(region.isocode);
  }
  toggleDefaultAddress() {
    this.addressForm['controls'].defaultAddress.setValue(this.addressForm.value.defaultAddress);
  }
  back() {
    this.backToAddress.emit();
  }
  verifyAddress() {
    if (this.addressForm.valid) {
      const regionControl = this.addressForm.get('region');
      const isocode = regionControl?.value?.isocode;
      if (isocode) {
        this.regions$.pipe(take(1)).subscribe(regions => {
          if (regions.length) {
            const selectedRegion = regions.find(region => region.isocode === isocode);
            regionControl?.patchValue({
              isocodeShort: selectedRegion?.isocodeShort
            });
          } else {
            regionControl?.reset();
          }
        });
      }
      if (this.addressForm.dirty) {
        this.subscription.add(this.userAddressService.verifyAddress(this.addressForm.value).subscribe(value => {
          this.handleAddressVerificationResults(value);
        }));
      } else {
        // address form value not changed
        // ignore duplicate address
        this.submitAddress.emit(undefined);
      }
    } else {
      this.addressForm.markAllAsTouched();
      this.globalMessageService.add({
        key: 'formErrors.globalMessage'
      }, GlobalMessageType.MSG_TYPE_ASSISTIVE);
    }
  }
  openSuggestedAddress(results) {
    this.launchDialogService.openDialogAndSubscribe("SUGGESTED_ADDRESSES" /* LAUNCH_CALLER.SUGGESTED_ADDRESSES */, this.element, {
      enteredAddress: this.addressForm.value,
      suggestedAddresses: results.suggestedAddresses
    });
    this.subscription.add(this.launchDialogService.dialogClose.pipe(filter(result => Boolean(result))).subscribe(result => {
      if (typeof result === 'object') {
        const address = {
          ...result,
          titleCode: this.addressForm.value.titleCode,
          phone: this.addressForm.value.phone,
          selected: true
        };
        this.submitAddress.emit(address);
      }
    }));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function AddressFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressFormComponent)(i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2.UserAddressService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i1.UserProfileFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddressFormComponent,
      selectors: [["cx-address-form"]],
      viewQuery: function AddressFormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      inputs: {
        addressData: "addressData",
        actionBtnLabel: "actionBtnLabel",
        cancelBtnLabel: "cancelBtnLabel",
        setAsDefaultField: "setAsDefaultField",
        showTitleCode: "showTitleCode",
        showCancelBtn: "showCancelBtn",
        countries: "countries"
      },
      outputs: {
        submitAddress: "submitAddress",
        backToAddress: "backToAddress"
      },
      standalone: false,
      decls: 93,
      vars: 84,
      consts: [["submit", ""], ["requiredAsterisk", ""], ["class", "form-legend", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], ["formGroupName", "country", 1, "form-group"], [4, "ngIf"], ["class", "form-group", 4, "ngIf"], [1, "form-group"], [1, "label-content", "required"], [3, "ngTemplateOutlet"], ["required", "true", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "line1", 1, "form-control", 3, "placeholder"], ["id", "line1Error", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "label-content"], ["type", "text", "formControlName", "line2", 1, "form-control", 3, "placeholder"], [1, "row"], [1, "form-group", "col-sm-6"], ["required", "true", "type", "text", "formControlName", "town", 1, "form-control", 3, "placeholder"], ["id", "townError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "postalCode", 1, "form-control", 3, "placeholder"], ["id", "postalCodeError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], ["formGroupName", "region", 4, "ngIf"], [1, "form-group", "col-md-6"], ["type", "tel", "formControlName", "phone", 1, "form-control", 3, "placeholder"], ["type", "tel", "formControlName", "cellphone", 1, "form-control", 3, "placeholder"], [1, "cx-address-form-btns"], ["class", "col-md-13 col-lg-6", 4, "ngIf"], [1, "col-md-13", "col-lg-6"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], [1, "form-legend"], ["id", "country-select", "formControlName", "isocode", "bindLabel", "name", "bindValue", "isocode", 1, "country-select", 3, "change", "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], [3, "translationParams", "control", 4, "cxFeature"], [3, "translationParams", "control"], [3, "control"], ["id", "title-select", "formControlName", "titleCode", "bindLabel", "name", "bindValue", "code", 3, "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], ["id", "firstNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "lastNameError", "aria-live", "off", 3, "translationParams", "control"], ["id", "line1Error", "aria-live", "off", 3, "translationParams", "control"], ["id", "townError", "aria-live", "off", 3, "translationParams", "control"], ["id", "postalCodeError", "aria-live", "off", 3, "translationParams", "control"], ["formGroupName", "region"], ["formControlName", "isocode", "id", "region-select", 1, "region-select", 3, "inputAttrs", "searchable", "clearable", "items", "bindLabel", "bindValue", "placeholder", "cxNgSelectA11y"], [1, "form-check"], ["type", "checkbox", "formControlName", "defaultAddress", 1, "form-check-input", 3, "change"], [1, "form-check-label"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function AddressFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, AddressFormComponent_p_0_Template, 3, 3, "p", 2);
          i0.ɵɵelementStart(1, "form", 3);
          i0.ɵɵlistener("ngSubmit", function AddressFormComponent_Template_form_ngSubmit_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.verifyAddress());
          });
          i0.ɵɵelementStart(2, "div", 4);
          i0.ɵɵtemplate(3, AddressFormComponent_ng_container_3_Template, 2, 1, "ng-container", 5);
          i0.ɵɵpipe(4, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, AddressFormComponent_div_5_Template, 3, 3, "div", 6);
          i0.ɵɵelementStart(6, "div", 7)(7, "label")(8, "span", 8);
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵtemplate(11, AddressFormComponent_ng_template_11_Template, 0, 0, "ng-template", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(12, "input", 10);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵtemplate(14, AddressFormComponent_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 11)(15, AddressFormComponent_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 12);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(16, "div", 7)(17, "label")(18, "span", 8);
          i0.ɵɵtext(19);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵtemplate(21, AddressFormComponent_ng_template_21_Template, 0, 0, "ng-template", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(22, "input", 13);
          i0.ɵɵpipe(23, "cxTranslate");
          i0.ɵɵtemplate(24, AddressFormComponent_cx_form_errors_24_Template, 2, 6, "cx-form-errors", 14)(25, AddressFormComponent_cx_form_errors_25_Template, 1, 1, "cx-form-errors", 12);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(26, "div", 7)(27, "label")(28, "span", 8);
          i0.ɵɵtext(29);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵtemplate(31, AddressFormComponent_ng_template_31_Template, 0, 0, "ng-template", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(32, "input", 15);
          i0.ɵɵpipe(33, "cxTranslate");
          i0.ɵɵtemplate(34, AddressFormComponent_cx_form_errors_34_Template, 2, 6, "cx-form-errors", 16)(35, AddressFormComponent_cx_form_errors_35_Template, 1, 1, "cx-form-errors", 12);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(36, "div", 7)(37, "label")(38, "span", 17);
          i0.ɵɵtext(39);
          i0.ɵɵpipe(40, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(41, "input", 18);
          i0.ɵɵpipe(42, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(43, "div", 19)(44, "div", 20)(45, "label")(46, "span", 8);
          i0.ɵɵtext(47);
          i0.ɵɵpipe(48, "cxTranslate");
          i0.ɵɵtemplate(49, AddressFormComponent_ng_template_49_Template, 0, 0, "ng-template", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(50, "input", 21);
          i0.ɵɵpipe(51, "cxTranslate");
          i0.ɵɵtemplate(52, AddressFormComponent_cx_form_errors_52_Template, 2, 6, "cx-form-errors", 22)(53, AddressFormComponent_cx_form_errors_53_Template, 1, 1, "cx-form-errors", 12);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(54, "div", 20)(55, "label")(56, "span", 8);
          i0.ɵɵtext(57);
          i0.ɵɵpipe(58, "cxTranslate");
          i0.ɵɵtemplate(59, AddressFormComponent_ng_template_59_Template, 0, 0, "ng-template", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(60, "input", 23);
          i0.ɵɵpipe(61, "cxTranslate");
          i0.ɵɵtemplate(62, AddressFormComponent_cx_form_errors_62_Template, 2, 6, "cx-form-errors", 24)(63, AddressFormComponent_cx_form_errors_63_Template, 1, 1, "cx-form-errors", 12);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(64, AddressFormComponent_ng_container_64_Template, 2, 1, "ng-container", 25);
          i0.ɵɵpipe(65, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(66, "div", 19)(67, "div", 26)(68, "label")(69, "span", 17);
          i0.ɵɵtext(70);
          i0.ɵɵpipe(71, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(72, "input", 27);
          i0.ɵɵpipe(73, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(74, "div", 26)(75, "label")(76, "span", 17);
          i0.ɵɵtext(77);
          i0.ɵɵpipe(78, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(79, "input", 28);
          i0.ɵɵpipe(80, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(81, AddressFormComponent_div_81_Template, 7, 3, "div", 6);
          i0.ɵɵpipe(82, "async");
          i0.ɵɵelementStart(83, "div", 29)(84, "div", 19);
          i0.ɵɵtemplate(85, AddressFormComponent_div_85_Template, 4, 3, "div", 30);
          i0.ɵɵelementStart(86, "div", 31)(87, "button", 32, 0);
          i0.ɵɵtext(89);
          i0.ɵɵpipe(90, "cxTranslate");
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵtemplate(91, AddressFormComponent_ng_template_91_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_43_0;
          const requiredAsterisk_r5 = i0.ɵɵreference(92);
          i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.addressForm);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 44, ctx.countries$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showTitleCode);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 46, "addressForm.firstName.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 48, "addressForm.firstName.placeholder"));
          i0.ɵɵattribute("aria-describedby", "firstNameError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(20, 50, "addressForm.lastName.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(23, 52, "addressForm.lastName.placeholder"));
          i0.ɵɵattribute("aria-describedby", "lastNameError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 54, "addressForm.address1"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(33, 56, "addressForm.streetAddress"));
          i0.ɵɵattribute("aria-describedby", "line1Error");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(40, 58, "addressForm.address2"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(42, 60, "addressForm.aptSuite"));
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(48, 62, "addressForm.city.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(51, 64, "addressForm.city.placeholder"));
          i0.ɵɵattribute("aria-describedby", "townError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(58, 66, "addressForm.zipCode.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r5);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(61, 68, "addressForm.zipCode.placeholder"));
          i0.ɵɵattribute("aria-describedby", "postalCodeError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(65, 70, ctx.regions$));
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 72, "addressForm.phoneNumber.label"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(73, 74, "addressForm.phoneNumber.placeholder"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(78, 76, "addressForm.cellphone.label"));
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(80, 78, "addressForm.cellphone.placeholder"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ((tmp_43_0 = i0.ɵɵpipeBind1(82, 80, ctx.addresses$)) == null ? null : tmp_43_0.length) && ctx.setAsDefaultField);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.showCancelBtn);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", ctx.actionBtnLabel || i0.ɵɵpipeBind1(90, 82, "common.continue"), " ");
        }
      },
      dependencies: [i4.NgSelectA11yDirective, i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormGroupName, i6.NgSelectComponent, i4.FormErrorsComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-address-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n<p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n  {{ 'formLegend.required' | cxTranslate }}\n</p>\n<form (ngSubmit)=\"verifyAddress()\" [formGroup]=\"addressForm\">\n  <div class=\"form-group\" formGroupName=\"country\">\n    <ng-container *ngIf=\"countries$ | async as countries\">\n      <div *ngIf=\"countries.length !== 0\">\n        <label>\n          <span class=\"label-content required\"\n            >{{ 'addressForm.country' | cxTranslate }}\n            <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n          </span>\n          <ng-select\n            [inputAttrs]=\"{ required: 'true' }\"\n            class=\"country-select\"\n            id=\"country-select\"\n            formControlName=\"isocode\"\n            [searchable]=\"true\"\n            [clearable]=\"false\"\n            [items]=\"countries\"\n            bindLabel=\"name\"\n            bindValue=\"isocode\"\n            placeholder=\"{{ 'addressForm.selectOne' | cxTranslate }}\"\n            (change)=\"countrySelected($event)\"\n            [cxNgSelectA11y]=\"{}\"\n          >\n          </ng-select>\n          <cx-form-errors\n            *cxFeature=\"'formErrorsDescriptiveMessages'\"\n            [translationParams]=\"{\n              label: 'addressForm.country' | cxTranslate,\n            }\"\n            [control]=\"addressForm.get('country.isocode')\"\n          ></cx-form-errors>\n          <cx-form-errors\n            *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n            [control]=\"addressForm.get('country.isocode')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n    </ng-container>\n  </div>\n  <div class=\"form-group\" *ngIf=\"showTitleCode\">\n    <ng-container *ngIf=\"titles$ | async as titles\">\n      <div *ngIf=\"titles.length !== 0\">\n        <label>\n          <span class=\"label-content required\">{{\n            'addressForm.titleOptional' | cxTranslate\n          }}</span>\n          <ng-select\n            id=\"title-select\"\n            formControlName=\"titleCode\"\n            [searchable]=\"true\"\n            [clearable]=\"false\"\n            [items]=\"titles\"\n            bindLabel=\"name\"\n            bindValue=\"code\"\n            [placeholder]=\"'addressForm.title' | cxTranslate\"\n            [cxNgSelectA11y]=\"{\n              ariaLabel: 'addressForm.title' | cxTranslate,\n            }\"\n          >\n          </ng-select>\n        </label>\n      </div>\n    </ng-container>\n  </div>\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content required\"\n        >{{ 'addressForm.firstName.label' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n      ></span>\n      <input\n        required=\"true\"\n        class=\"form-control\"\n        type=\"text\"\n        placeholder=\"{{ 'addressForm.firstName.placeholder' | cxTranslate }}\"\n        formControlName=\"firstName\"\n        [attr.aria-describedby]=\"'firstNameError'\"\n      />\n      <cx-form-errors\n        *cxFeature=\"'formErrorsDescriptiveMessages'\"\n        id=\"firstNameError\"\n        aria-live=\"off\"\n        [translationParams]=\"{\n          label: 'addressForm.firstName.label' | cxTranslate,\n        }\"\n        [control]=\"addressForm.get('firstName')\"\n      ></cx-form-errors>\n      <cx-form-errors\n        *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n        [control]=\"addressForm.get('firstName')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content required\"\n        >{{ 'addressForm.lastName.label' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n      ></span>\n      <input\n        required=\"true\"\n        type=\"text\"\n        class=\"form-control\"\n        placeholder=\"{{ 'addressForm.lastName.placeholder' | cxTranslate }}\"\n        formControlName=\"lastName\"\n        [attr.aria-describedby]=\"'lastNameError'\"\n      />\n      <cx-form-errors\n        *cxFeature=\"'formErrorsDescriptiveMessages'\"\n        id=\"lastNameError\"\n        aria-live=\"off\"\n        [translationParams]=\"{\n          label: 'addressForm.lastName.label' | cxTranslate,\n        }\"\n        [control]=\"addressForm.get('lastName')\"\n      ></cx-form-errors>\n      <cx-form-errors\n        *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n        [control]=\"addressForm.get('lastName')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content required\"\n        >{{ 'addressForm.address1' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n      ></span>\n      <input\n        required=\"true\"\n        type=\"text\"\n        class=\"form-control\"\n        placeholder=\"{{ 'addressForm.streetAddress' | cxTranslate }}\"\n        formControlName=\"line1\"\n        [attr.aria-describedby]=\"'line1Error'\"\n      />\n      <cx-form-errors\n        *cxFeature=\"'formErrorsDescriptiveMessages'\"\n        id=\"line1Error\"\n        aria-live=\"off\"\n        [translationParams]=\"{\n          label: 'addressForm.address1' | cxTranslate,\n        }\"\n        [control]=\"addressForm.get('line1')\"\n      ></cx-form-errors>\n      <cx-form-errors\n        *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n        [control]=\"addressForm.get('line1')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content\">{{\n        'addressForm.address2' | cxTranslate\n      }}</span>\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        placeholder=\"{{ 'addressForm.aptSuite' | cxTranslate }}\"\n        formControlName=\"line2\"\n      />\n    </label>\n  </div>\n  <div class=\"row\">\n    <div class=\"form-group col-sm-6\">\n      <label>\n        <span class=\"label-content required\"\n          >{{ 'addressForm.city.label' | cxTranslate }}\n          <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n        ></span>\n        <input\n          required=\"true\"\n          type=\"text\"\n          class=\"form-control\"\n          placeholder=\"{{ 'addressForm.city.placeholder' | cxTranslate }}\"\n          formControlName=\"town\"\n          [attr.aria-describedby]=\"'townError'\"\n        />\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"townError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'addressForm.city.label' | cxTranslate,\n          }\"\n          [control]=\"addressForm.get('town')\"\n        ></cx-form-errors>\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"addressForm.get('town')\"\n        ></cx-form-errors>\n      </label>\n    </div>\n    <div class=\"form-group col-sm-6\">\n      <label>\n        <span class=\"label-content required\"\n          >{{ 'addressForm.zipCode.label' | cxTranslate }}\n          <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n        ></span>\n        <input\n          required=\"true\"\n          type=\"text\"\n          class=\"form-control\"\n          placeholder=\"{{ 'addressForm.zipCode.placeholder' | cxTranslate }}\"\n          formControlName=\"postalCode\"\n          [attr.aria-describedby]=\"'postalCodeError'\"\n        />\n        <cx-form-errors\n          *cxFeature=\"'formErrorsDescriptiveMessages'\"\n          id=\"postalCodeError\"\n          aria-live=\"off\"\n          [translationParams]=\"{\n            label: 'addressForm.zipCode.label' | cxTranslate,\n          }\"\n          [control]=\"addressForm.get('postalCode')\"\n        ></cx-form-errors>\n        <cx-form-errors\n          *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n          [control]=\"addressForm.get('postalCode')\"\n        ></cx-form-errors>\n      </label>\n    </div>\n    <ng-container *ngIf=\"regions$ | async as regions\" formGroupName=\"region\">\n      <ng-container *ngIf=\"regions.length !== 0\">\n        <div class=\"form-group col-md-6\">\n          <label>\n            <span class=\"label-content required\"\n              >{{ 'addressForm.state' | cxTranslate }}\n              <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n            ></span>\n            <ng-select\n              [inputAttrs]=\"{ required: 'true' }\"\n              class=\"region-select\"\n              formControlName=\"isocode\"\n              [searchable]=\"true\"\n              [clearable]=\"false\"\n              [items]=\"regions\"\n              bindLabel=\"{{ regions[0].name ? 'name' : 'isocode' }}\"\n              bindValue=\"{{ regions[0].name ? 'isocode' : 'region' }}\"\n              placeholder=\"{{ 'addressForm.selectOne' | cxTranslate }}\"\n              id=\"region-select\"\n              [cxNgSelectA11y]=\"{\n                ariaLabel: 'addressForm.state' | cxTranslate,\n              }\"\n            >\n            </ng-select>\n            <cx-form-errors\n              [control]=\"addressForm.get('region.isocode')\"\n            ></cx-form-errors>\n          </label>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"form-group col-md-6\">\n      <label>\n        <span class=\"label-content\">{{\n          'addressForm.phoneNumber.label' | cxTranslate\n        }}</span>\n        <input\n          type=\"tel\"\n          class=\"form-control\"\n          placeholder=\"{{\n            'addressForm.phoneNumber.placeholder' | cxTranslate\n          }}\"\n          formControlName=\"phone\"\n        />\n      </label>\n    </div>\n    <div class=\"form-group col-md-6\">\n      <label>\n        <span class=\"label-content\">{{\n          'addressForm.cellphone.label' | cxTranslate\n        }}</span>\n        <input\n          type=\"tel\"\n          class=\"form-control\"\n          placeholder=\"{{ 'addressForm.cellphone.placeholder' | cxTranslate }}\"\n          formControlName=\"cellphone\"\n        />\n      </label>\n    </div>\n  </div>\n\n  <div\n    class=\"form-group\"\n    *ngIf=\"(addresses$ | async)?.length && setAsDefaultField\"\n  >\n    <div class=\"form-check\">\n      <label>\n        <input\n          type=\"checkbox\"\n          class=\"form-check-input\"\n          formControlName=\"defaultAddress\"\n          (change)=\"toggleDefaultAddress()\"\n        />\n        <span class=\"form-check-label\">{{\n          'addressForm.setAsDefault' | cxTranslate\n        }}</span>\n      </label>\n    </div>\n  </div>\n  <div class=\"cx-address-form-btns\">\n    <div class=\"row\">\n      <div class=\"col-md-13 col-lg-6\" *ngIf=\"showCancelBtn\">\n        <button class=\"btn btn-block btn-secondary\" (click)=\"back()\">\n          {{ cancelBtnLabel || ('addressForm.chooseAddress' | cxTranslate) }}\n        </button>\n      </div>\n      <div class=\"col-md-13 col-lg-6\">\n        <button #submit class=\"btn btn-block btn-primary\" type=\"submit\">\n          {{ actionBtnLabel || ('common.continue' | cxTranslate) }}\n        </button>\n      </div>\n    </div>\n  </div>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: i3.UntypedFormBuilder
  }, {
    type: i2.UserAddressService
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.TranslationService
  }, {
    type: i4.LaunchDialogService
  }, {
    type: i1.UserProfileFacade
  }], {
    addressData: [{
      type: Input
    }],
    actionBtnLabel: [{
      type: Input
    }],
    cancelBtnLabel: [{
      type: Input
    }],
    setAsDefaultField: [{
      type: Input
    }],
    showTitleCode: [{
      type: Input
    }],
    showCancelBtn: [{
      type: Input
    }],
    countries: [{
      type: Input
    }],
    submitAddress: [{
      type: Output
    }],
    backToAddress: [{
      type: Output
    }],
    element: [{
      type: ViewChild,
      args: ['submit']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddressBookComponent {
  constructor(service, translation, globalMessageService) {
    this.service = service;
    this.translation = translation;
    this.globalMessageService = globalMessageService;
    this.showAddAddressForm = false;
    this.showEditAddressForm = false;
  }
  ngOnInit() {
    this.addresses$ = this.service.getAddresses();
    this.addressesStateLoading$ = this.service.getAddressesStateLoading();
    this.service.loadAddresses();
  }
  addAddressButtonHandle() {
    this.showEditAddressForm = false;
    this.showAddAddressForm = true;
  }
  editAddressButtonHandle(address) {
    this.showAddAddressForm = false;
    this.showEditAddressForm = true;
    this.currentAddress = address;
  }
  addAddressSubmit(address) {
    this.showAddAddressForm = false;
    this.service.addUserAddress(address);
  }
  addAddressCancel() {
    this.showAddAddressForm = false;
  }
  editAddressSubmit(address) {
    this.showEditAddressForm = false;
    if (address && this.currentAddress['id']) {
      this.service.updateUserAddress(this.currentAddress['id'], address);
    }
  }
  editAddressCancel() {
    this.showEditAddressForm = false;
  }
  getCardContent(address) {
    return combineLatest([this.translation.translate('addressCard.default'), this.translation.translate('addressCard.setAsDefault'), this.translation.translate('common.delete'), this.translation.translate('common.edit'), this.translation.translate('addressBook.areYouSureToDeleteAddress'), this.translation.translate('addressCard.phoneNumber'), this.translation.translate('addressCard.mobileNumber')]).pipe(map(([defaultText, setAsDefaultText, textDelete, textEdit, textVerifyDeleteMsg, textPhone, textMobile]) => {
      let region = '';
      if (address.region && address.region.isocode) {
        region = address.region.isocode + ', ';
      }
      const actions = [];
      if (!address.defaultAddress) {
        actions.push({
          name: setAsDefaultText,
          event: 'default'
        });
      }
      actions.push({
        name: textEdit,
        event: 'edit'
      });
      actions.push({
        name: textDelete,
        event: 'delete'
      });
      const numbers = getAddressNumbers(address, textPhone, textMobile);
      return {
        role: 'application',
        textBold: address.firstName + ' ' + address.lastName,
        text: [address.line1, address.line2, address.town + ', ' + region + address.country?.isocode, address.postalCode, numbers],
        actions: actions,
        header: address.defaultAddress ? `✓ ${defaultText}` : '',
        deleteMsg: textVerifyDeleteMsg,
        label: address.defaultAddress ? 'addressBook.defaultDeliveryAddress' : 'addressBook.additionalDeliveryAddress'
      };
    }));
  }
  setAddressAsDefault(address) {
    this.service.setAddressAsDefault(address.id ?? '');
    this.globalMessageService.add({
      key: 'addressMessages.setAsDefaultSuccessfully',
      params: {
        streetAddress: address.line1
      }
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
  }
  deleteAddress(addressId) {
    this.service.deleteUserAddress(addressId);
  }
  setEdit(addressId) {
    if (this.editCard !== addressId) {
      this.editCard = addressId;
    } else {
      this.deleteAddress(addressId);
    }
  }
  cancelCard() {
    this.editCard = null;
  }
  static {
    this.ɵfac = function AddressBookComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressBookComponent)(i0.ɵɵdirectiveInject(AddressBookComponentService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddressBookComponent,
      selectors: [["cx-address-book"]],
      standalone: false,
      decls: 8,
      vars: 7,
      consts: [["loading", ""], [1, "cx-section"], [4, "ngIf"], [1, "row"], [1, "col-md-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["class", "row cx-address-deck", 4, "ngIf", "ngIfElse"], [1, "row", "cx-address-deck"], ["role", "status", 4, "cxFeature"], ["class", "col-md-6 cx-address-card", 4, "ngFor", "ngForOf"], ["role", "status"], [1, "col-md-6", "cx-address-card"], [3, "editCard", "setDefaultCard", "deleteCard", "cancelCard", "index", "border", "fitToContainer", "content", "editMode"], [1, "cx-section-msg"], [1, "cx-form", 3, "submitAddress", "backToAddress", "cancelCard", "showTitleCode", "showCancelBtn", "actionBtnLabel", "cancelBtnLabel", "setAsDefaultField"], [3, "submitAddress", "backToAddress", "showTitleCode", "actionBtnLabel", "cancelBtnLabel", "addressData"], [1, "col-md-12", "cx-address-spinner"]],
      template: function AddressBookComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, AddressBookComponent_ng_container_1_Template, 8, 7, "ng-container", 2);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵtemplate(3, AddressBookComponent_ng_container_3_Template, 10, 16, "ng-container", 2);
          i0.ɵɵpipe(4, "async");
          i0.ɵɵtemplate(5, AddressBookComponent_ng_container_5_Template, 8, 11, "ng-container", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, AddressBookComponent_ng_template_6_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_1_0;
          let tmp_2_0;
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ((tmp_1_0 = i0.ɵɵpipeBind1(2, 3, ctx.addresses$)) == null ? null : tmp_1_0.length) && !(ctx.showAddAddressForm || ctx.showEditAddressForm));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (!((tmp_2_0 = i0.ɵɵpipeBind1(4, 5, ctx.addresses$)) == null ? null : tmp_2_0.length) || ctx.showAddAddressForm) && !ctx.showEditAddressForm);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showEditAddressForm);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i4.CardComponent, AddressFormComponent, i4.SpinnerComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressBookComponent, [{
    type: Component,
    args: [{
      selector: 'cx-address-book',
      standalone: false,
      template: "<div class=\"cx-section\">\n  <ng-container\n    *ngIf=\"\n      (addresses$ | async)?.length &&\n      !(showAddAddressForm || showEditAddressForm)\n    \"\n  >\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <button\n          class=\"btn btn-block btn-secondary\"\n          (click)=\"addAddressButtonHandle()\"\n        >\n          {{ 'addressBook.addNewAddress' | cxTranslate }}\n        </button>\n      </div>\n    </div>\n\n    <div\n      class=\"row cx-address-deck\"\n      *ngIf=\"!(addressesStateLoading$ | async); else loading\"\n    >\n      <div\n        *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n        role=\"status\"\n        [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n      ></div>\n      <div\n        *ngFor=\"let address of addresses$ | async; let i = index\"\n        class=\"col-md-6 cx-address-card\"\n      >\n        <cx-card\n          [index]=\"i\"\n          [border]=\"true\"\n          [fitToContainer]=\"true\"\n          [content]=\"getCardContent(address) | async\"\n          (editCard)=\"editAddressButtonHandle(address)\"\n          (setDefaultCard)=\"setAddressAsDefault(address)\"\n          (deleteCard)=\"setEdit(address.id ?? '')\"\n          [editMode]=\"address.id === editCard\"\n          (cancelCard)=\"cancelCard()\"\n        ></cx-card>\n      </div>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"\n      (!(addresses$ | async)?.length || showAddAddressForm) &&\n      !showEditAddressForm\n    \"\n  >\n    <section>\n      <h2 class=\"cx-section-msg\">\n        {{ 'addressBook.addNewDeliveryAddress' | cxTranslate }}\n      </h2>\n      <cx-address-form\n        class=\"cx-form\"\n        [showTitleCode]=\"true\"\n        [showCancelBtn]=\"!((addresses$ | async)?.length === 0)\"\n        actionBtnLabel=\"{{ 'addressBook.addAddress' | cxTranslate }}\"\n        cancelBtnLabel=\"{{ 'addressBook.backToAddressList' | cxTranslate }}\"\n        [setAsDefaultField]=\"!((addresses$ | async)?.length === 0)\"\n        (submitAddress)=\"addAddressSubmit($event)\"\n        (backToAddress)=\"addAddressCancel()\"\n        (cancelCard)=\"cancelCard()\"\n      ></cx-address-form>\n    </section>\n  </ng-container>\n\n  <ng-container *ngIf=\"showEditAddressForm\">\n    <section>\n      <h2 class=\"cx-section-msg\">\n        {{ 'addressBook.editDeliveryAddress' | cxTranslate }}\n      </h2>\n      <cx-address-form\n        [showTitleCode]=\"true\"\n        actionBtnLabel=\"{{ 'addressBook.updateAddress' | cxTranslate }}\"\n        cancelBtnLabel=\"{{ 'addressBook.backToAddressList' | cxTranslate }}\"\n        [addressData]=\"currentAddress\"\n        (submitAddress)=\"editAddressSubmit($event)\"\n        (backToAddress)=\"editAddressCancel()\"\n      ></cx-address-form>\n    </section>\n  </ng-container>\n</div>\n\n<ng-template #loading>\n  <div class=\"col-md-12 cx-address-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: AddressBookComponentService
  }, {
    type: i2.TranslationService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SuggestedAddressDialogComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.closeModal('Cross click');
    }
  }
  constructor(launchDialogService, el) {
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    this.data$ = this.launchDialogService.data$;
    useFeatureStyles('a11yExpandedFocusIndicator');
  }
  ngOnInit() {
    this.data$.pipe(take(1)).subscribe(data => this.setSelectedAddress(data));
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  setSelectedAddress(data) {
    this.selectedAddress = data.suggestedAddresses?.length ? data.suggestedAddresses[0] : data.enteredAddress;
  }
  static {
    this.ɵfac = function SuggestedAddressDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SuggestedAddressDialogComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SuggestedAddressDialogComponent,
      selectors: [["cx-suggested-addresses-dialog"]],
      hostBindings: function SuggestedAddressDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 3,
      vars: 4,
      consts: [["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "modal-lg", "cx-suggested-addresses-dialog", 3, "esc", "cxFocus"], ["class", "modal-content cx-suggested-addresses-container", 4, "ngIf"], [1, "modal-content", "cx-suggested-addresses-container"], [1, "cx-suggested-addresses-header", "cx-modal-header"], ["id", "dialogTitle", "class", "cx-suggested-addresses-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], ["ngForm", "", 1, "modal-body"], [1, "cx-dialog-info"], [1, "cx-dialog-options"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "form-check"], ["type", "radio", "name", "selectedAddress", "id", "suggested-addresses--entered", 1, "form-check-input", 3, "ngModelChange", "ngModel", "value"], ["for", "suggested-addresses--entered", 1, "form-check-label", "cx-dialog-label"], [1, "cx-dialog-entered"], [1, "cx-card-container"], [1, "cx-card-label"], [1, "cx-suggested-addresses-footer", "cx-modal-footer"], [1, "row"], [1, "cx-dialog-actions", "col-sm-12", "col-md-12", "col-lg-6", "offset-lg-6"], [1, "btn", "btn-secondary", "cx-dialog-buttons", 3, "click"], ["cxAutoFocus", "", 1, "btn", "btn-primary", "cx-dialog-buttons", 3, "click"], ["id", "dialogTitle", 1, "cx-suggested-addresses-title"], ["type", "radio", "name", "selectedAddress", 1, "form-check-input", 3, "ngModelChange", "ngModel", "value", "id"], [1, "form-check-label", "cx-dialog-label", 3, "for"], [1, "cx-dialog-suggested"]],
      template: function SuggestedAddressDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function SuggestedAddressDialogComponent_Template_div_esc_0_listener() {
            return ctx.closeModal("Escape clicked");
          });
          i0.ɵɵtemplate(1, SuggestedAddressDialogComponent_div_1_Template, 44, 34, "div", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.data$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.DefaultValueAccessor, i3.RadioControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.NgModel, i3.NgForm, i4.IconComponent, i4.FocusDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SuggestedAddressDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-suggested-addresses-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg cx-suggested-addresses-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div\n    *ngIf=\"data$ | async as data\"\n    class=\"modal-content cx-suggested-addresses-container\"\n  >\n    <div class=\"cx-suggested-addresses-header cx-modal-header\">\n      <h3\n        *cxFeature=\"'a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-suggested-addresses-title\"\n      >\n        {{ 'addressSuggestion.verifyYourAddress' | cxTranslate }}\n      </h3>\n      <div\n        *cxFeature=\"'!a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-suggested-addresses-title\"\n      >\n        {{ 'addressSuggestion.verifyYourAddress' | cxTranslate }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"closeModal('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <div class=\"modal-body\" ngForm>\n      <div class=\"cx-dialog-info\">\n        <p>\n          {{ 'addressSuggestion.ensureAccuracySuggestChange' | cxTranslate }}\n          {{ 'addressSuggestion.chooseAddressToUse' | cxTranslate }}\n        </p>\n      </div>\n\n      <div class=\"cx-dialog-options\">\n        <div\n          class=\"form-check\"\n          *ngFor=\"\n            let suggestedAddress of data.suggestedAddresses;\n            let i = index\n          \"\n        >\n          <input\n            class=\"form-check-input\"\n            type=\"radio\"\n            name=\"selectedAddress\"\n            [(ngModel)]=\"selectedAddress\"\n            [value]=\"suggestedAddress\"\n            [id]=\"'suggested-addresses--suggested-' + i\"\n          />\n          <label\n            class=\"form-check-label cx-dialog-label\"\n            [for]=\"'suggested-addresses--suggested-' + i\"\n          >\n            {{ 'addressSuggestion.suggestedAddress' | cxTranslate }}\n            {{ data.suggestedAddresses.length > 1 ? i + 1 : null }}\n          </label>\n          <div class=\"cx-dialog-suggested\">\n            <div class=\"cx-card-container\">\n              <div class=\"cx-card-label\">{{ suggestedAddress?.firstName }}</div>\n              <div class=\"cx-card-label\">{{ suggestedAddress?.lastName }}</div>\n              <div class=\"cx-card-label\">{{ suggestedAddress?.line1 }}</div>\n              <div class=\"cx-card-label\">\n                <span>{{ suggestedAddress?.line2 }}</span>\n              </div>\n              <div class=\"cx-card-label\">{{ suggestedAddress?.town }}</div>\n              <div class=\"cx-card-label\">\n                {{ suggestedAddress?.region?.isocode }}\n              </div>\n              <div class=\"cx-card-label\">\n                {{ suggestedAddress?.postalCode }}\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-check\">\n          <input\n            class=\"form-check-input\"\n            type=\"radio\"\n            name=\"selectedAddress\"\n            [(ngModel)]=\"selectedAddress\"\n            [value]=\"data.enteredAddress\"\n            id=\"suggested-addresses--entered\"\n          />\n          <label\n            class=\"form-check-label cx-dialog-label\"\n            for=\"suggested-addresses--entered\"\n          >\n            {{ 'addressSuggestion.enteredAddress' | cxTranslate }}\n          </label>\n          <div class=\"cx-dialog-entered\">\n            <div class=\"cx-card-container\">\n              <div class=\"cx-card-label\">\n                {{ data.enteredAddress?.firstName }}\n                {{ data.enteredAddress?.lastName }}\n              </div>\n              <div class=\"cx-card-label\">{{ data.enteredAddress?.line1 }}</div>\n              <div class=\"cx-card-label\">\n                <span>{{ data.enteredAddress?.line2 }}</span>\n              </div>\n              <div class=\"cx-card-label\">\n                {{ data.enteredAddress?.town }}\n                {{ data.enteredAddress?.region?.isocode }}\n              </div>\n              <div class=\"cx-card-label\">\n                {{ data.enteredAddress?.postalCode }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"cx-suggested-addresses-footer cx-modal-footer\">\n      <div class=\"row\">\n        <div class=\"cx-dialog-actions col-sm-12 col-md-12 col-lg-6 offset-lg-6\">\n          <button\n            class=\"btn btn-secondary cx-dialog-buttons\"\n            (click)=\"closeModal('Edit address')\"\n          >\n            {{ 'addressSuggestion.editAddress' | cxTranslate }}\n          </button>\n          <button\n            cxAutoFocus\n            class=\"btn btn-primary cx-dialog-buttons\"\n            (click)=\"closeModal(selectedAddress)\"\n          >\n            {{ 'addressSuggestion.saveAddress' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i4.LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddressFormModule {
  static {
    this.ɵfac = function AddressFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddressFormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NgSelectA11yModule, CommonModule, ReactiveFormsModule, FormsModule, RouterModule, NgSelectModule, IconModule, I18nModule, FormErrorsModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressFormModule, [{
    type: NgModule,
    args: [{
      imports: [NgSelectA11yModule, CommonModule, ReactiveFormsModule, FormsModule, RouterModule, NgSelectModule, IconModule, I18nModule, FormErrorsModule, KeyboardFocusModule, FeaturesConfigModule],
      declarations: [AddressFormComponent, SuggestedAddressDialogComponent],
      exports: [AddressFormComponent, SuggestedAddressDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSuggestedAddressesDialogLayoutConfig = {
  launch: {
    SUGGESTED_ADDRESSES: {
      inlineRoot: true,
      component: SuggestedAddressDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddressBookModule {
  static {
    this.ɵfac = function AddressBookModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressBookModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddressBookModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountAddressBookComponent: {
            component: AddressBookComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultSuggestedAddressesDialogLayoutConfig), UserAddressService],
      imports: [CommonModule, CardModule, AddressFormModule, SpinnerModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressBookModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CardModule, AddressFormModule, SpinnerModule, I18nModule, FeaturesConfigModule],
      declarations: [AddressBookComponent],
      exports: [AddressBookComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountAddressBookComponent: {
            component: AddressBookComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultSuggestedAddressesDialogLayoutConfig), UserAddressService]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ONE_TIME_PASSWORD_REGISTRATION_PURPOSE = 'REGISTRATION';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OneTimePasswordRegisterComponent {
  get additionalConsents() {
    return this.registerForm?.get('additionalConsents');
  }
  updateAdditionalConsents(event, index) {
    const {
      checked
    } = event.target;
    this.registerForm.value.additionalConsents[index] = checked;
  }
  constructor() {
    this.globalMessageService = inject(GlobalMessageService);
    this.fb = inject(UntypedFormBuilder);
    this.router = inject(RoutingService);
    this.anonymousConsentsService = inject(AnonymousConsentsService);
    this.anonymousConsentsConfig = inject(AnonymousConsentsConfig);
    this.clientAuthenticationTokenService = inject(ClientAuthenticationTokenService);
    this.registerComponentService = inject(RegisterComponentService);
    this.routingService = inject(RoutingService);
    this.registrationVerificationTokenFacade = inject(VerificationTokenFacade);
    this.isLoading$ = new BehaviorSubject(false);
    this.subscription = new Subscription();
    this.registerForm = this.fb.group({
      titleCode: [null],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      newsletter: new UntypedFormControl({
        value: false,
        disabled: this.isConsentRequired()
      }),
      additionalConsents: this.registerComponentService.generateAdditionalConsentsFormControl?.() ?? this.fb.array([]),
      termsandconditions: [false, Validators.requiredTrue],
      captcha: [false, Validators.requiredTrue]
    });
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  ngOnInit() {
    this.titles$ = this.registerComponentService.getTitles().pipe(map$1(titles => {
      return titles.sort(sortTitles);
    }));
    // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
    this.subscription.add(this.globalMessageService.get().pipe(filter$1(messages => !!Object.keys(messages).length)).subscribe(globalMessageEntities => {
      const messages = globalMessageEntities && globalMessageEntities[GlobalMessageType.MSG_TYPE_ERROR];
      if (messages && messages.some(message => message.raw === 'This field is required.')) {
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        this.globalMessageService.add({
          key: 'register.titleRequired'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
    }));
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent ?? '';
    this.anonymousConsent$ = combineLatest([this.anonymousConsentsService.getConsent(registerConsent), this.anonymousConsentsService.getTemplate(registerConsent)]).pipe(map$1(([consent, template]) => {
      return {
        consent,
        template: template?.description ? template.description : ''
      };
    }));
    this.additionalRegistrationConsents = this.registerComponentService?.getAdditionalConsents() || [];
    this.subscription.add(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.registerForm.get('newsletter')?.valueChanges.subscribe(() => {
      this.toggleAnonymousConsent();
    }));
  }
  submitForm() {
    if (this.registerForm.valid) {
      this.sendRegistrationVerificationToken();
    } else {
      this.registerForm.markAllAsTouched();
    }
  }
  sendRegistrationVerificationToken() {
    this.isLoading$.next(true);
    this.clientAuthenticationTokenService.loadClientAuthenticationToken();
    const registrationVerificationTokenCreation = this.collectDataFromRegisterForm();
    this.registrationVerificationTokenFacade.createVerificationToken(registrationVerificationTokenCreation).subscribe({
      next: result => this.goToVerificationTokenForm(result),
      error: error => {
        this.routingService.go({
          cxRoute: 'verifyTokenForRegistration'
        }, {
          state: {
            errorStatus: error.status,
            titleCode: this.registerForm.value.titleCode,
            firstName: this.registerForm.value.firstName,
            lastName: this.registerForm.value.lastName,
            loginId: this.registerForm.value.email.toLowerCase()
          }
        });
        this.isLoading$.next(false);
      },
      complete: () => this.onCreateRegistrationVerificationTokenComplete()
    });
  }
  onCreateRegistrationVerificationTokenComplete() {
    this.isLoading$.next(false);
  }
  collectDataFromRegisterForm() {
    return {
      loginId: this.registerForm.value.email.toLowerCase(),
      purpose: ONE_TIME_PASSWORD_REGISTRATION_PURPOSE
    };
  }
  goToVerificationTokenForm(registrationVerificationToken) {
    this.routingService.go({
      cxRoute: 'verifyTokenForRegistration'
    }, {
      state: {
        loginId: this.registerForm.value.email.toLowerCase(),
        tokenId: registrationVerificationToken.tokenId,
        expiresIn: registrationVerificationToken.expiresIn,
        titleCode: this.registerForm.value.titleCode,
        firstName: this.registerForm.value.firstName,
        lastName: this.registerForm.value.lastName
      }
    });
  }
  isConsentGiven(consent) {
    return this.anonymousConsentsService.isConsentGiven(consent);
  }
  isConsentRequired() {
    const requiredConsents = this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents;
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
    if (requiredConsents && registerConsent) {
      return requiredConsents.includes(registerConsent);
    }
    return false;
  }
  toggleAnonymousConsent() {
    const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
    if (registerConsent) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (Boolean(this.registerForm.get('newsletter')?.value)) {
        this.anonymousConsentsService.giveConsent(registerConsent);
      } else {
        this.anonymousConsentsService.withdrawConsent(registerConsent);
      }
    }
  }
  /**
   * Triggered via CaptchaComponent when a user confirms captcha
   */
  captchaConfirmed() {
    this.registerForm.get('captcha')?.setValue(true);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function OneTimePasswordRegisterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OneTimePasswordRegisterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OneTimePasswordRegisterComponent,
      selectors: [["cx-otp-register-form"]],
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [["requiredAsterisk", ""], ["loading", ""], ["class", "cx-page-section container", 4, "ngIf", "ngIfElse"], [1, "cx-page-section", "container"], ["role", "status", 4, "cxFeature"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "cx-section"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["bindLabel", "name", "bindValue", "code", "formControlName", "titleCode", "id", "title-select", 3, "clearable", "items", "placeholder", "searchable", "cxNgSelectA11y"], [3, "ngTemplateOutlet"], ["required", "true", "type", "text", "name", "firstname", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], [3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastname", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], [1, "form-check"], [4, "ngIf"], ["formArrayName", "additionalConsents", "class", "form-group", 4, "ngIf"], ["required", "true", "type", "checkbox", "name", "termsandconditions", "formControlName", "termsandconditions"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 3, "routerLink"], [3, "confirmed"], [3, "control"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], [1, "cx-login-link", "btn-link", 3, "routerLink"], ["role", "status"], [3, "translationParams", "control"], ["type", "checkbox", "name", "newsletter", "formControlName", "newsletter", 1, "form-check-input", 3, "checked"], ["formArrayName", "additionalConsents", 1, "form-group"], ["class", "form-check", 4, "ngFor", "ngForOf"], ["type", "checkbox", 3, "change", "required", "name", "formControlName"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"], [1, "cx-spinner"]],
      template: function OneTimePasswordRegisterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OneTimePasswordRegisterComponent_section_0_Template, 72, 70, "section", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, OneTimePasswordRegisterComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, OneTimePasswordRegisterComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r11 = i0.ɵɵreference(5);
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx.isLoading$))("ngIfElse", loading_r11);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i5.RouterLink, i2.FeatureDirective, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.CheckboxRequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormArrayName, i6.NgSelectComponent, i4.NgSelectA11yDirective, i4.CaptchaComponent, i4.SpinnerComponent, i4.FormErrorsComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OneTimePasswordRegisterComponent, [{
    type: Component,
    args: [{
      selector: 'cx-otp-register-form',
      standalone: false,
      template: "<section\n  class=\"cx-page-section container\"\n  *ngIf=\"!(isLoading$ | async); else loading\"\n>\n  <div\n    *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n    role=\"status\"\n    [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n  ></div>\n  <div class=\"row justify-content-center\">\n    <div class=\"col-md-6\">\n      <div class=\"cx-section\">\n        <form (ngSubmit)=\"submitForm()\" [formGroup]=\"registerForm\">\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\">{{\n                'register.title' | cxTranslate\n              }}</span>\n              <ng-select\n                [clearable]=\"false\"\n                [items]=\"titles$ | async\"\n                [placeholder]=\"'register.selectTitle' | cxTranslate\"\n                [searchable]=\"false\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                formControlName=\"titleCode\"\n                id=\"title-select\"\n                [cxNgSelectA11y]=\"{}\"\n              >\n              </ng-select>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.firstName.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"text\"\n                name=\"firstname\"\n                placeholder=\"{{\n                  'register.firstName.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"firstName\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                [translationParams]=\"{\n                  label: 'register.firstName.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('firstName')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('firstName')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.lastName.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"text\"\n                name=\"lastname\"\n                placeholder=\"{{\n                  'register.lastName.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"lastName\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                [translationParams]=\"{\n                  label: 'register.lastName.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('lastName')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('lastName')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <label>\n              <span class=\"label-content\"\n                >{{ 'register.emailAddress.label' | cxTranslate }}\n                <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n              ></span>\n              <input\n                required=\"true\"\n                class=\"form-control\"\n                type=\"email\"\n                name=\"email\"\n                placeholder=\"{{\n                  'register.emailAddress.placeholder' | cxTranslate\n                }}\"\n                formControlName=\"email\"\n              />\n\n              <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n              <cx-form-errors\n                *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                [translationParams]=\"{\n                  label: 'register.emailAddress.label' | cxTranslate,\n                }\"\n                [control]=\"registerForm.get('email')\"\n              ></cx-form-errors>\n\n              <cx-form-errors\n                *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                [control]=\"registerForm.get('email')\"\n              ></cx-form-errors>\n            </label>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"form-check\">\n              <label *ngIf=\"anonymousConsent$ | async as anonymousConsent\">\n                <input\n                  type=\"checkbox\"\n                  name=\"newsletter\"\n                  class=\"form-check-input\"\n                  formControlName=\"newsletter\"\n                  [checked]=\"isConsentGiven(anonymousConsent.consent)\"\n                />\n                <span class=\"form-check-label\">\n                  {{ anonymousConsent.template }}\n                </span>\n              </label>\n            </div>\n          </div>\n\n          <div\n            formArrayName=\"additionalConsents\"\n            class=\"form-group\"\n            *ngIf=\"additionalRegistrationConsents as consents\"\n          >\n            <div\n              class=\"form-check\"\n              *ngFor=\"let control of additionalConsents.controls; let i = index\"\n            >\n              <div *ngIf=\"consents[i]?.template?.id as id\">\n                <label>\n                  <input\n                    type=\"checkbox\"\n                    [required]=\"consents[i].required\"\n                    [name]=\"id\"\n                    (change)=\"updateAdditionalConsents($any($event), i)\"\n                    [formControlName]=\"i\"\n                  />\n                  <span class=\"form-check-label\">\n                    {{ consents[i].template.description }}\n                  </span>\n                  <cx-form-errors [control]=\"control\"></cx-form-errors>\n                </label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"form-check\">\n              <label>\n                <input\n                  required=\"true\"\n                  type=\"checkbox\"\n                  name=\"termsandconditions\"\n                  formControlName=\"termsandconditions\"\n                />\n                <span class=\"form-check-label\">\n                  {{ 'register.confirmThatRead' | cxTranslate }}\n                  <a\n                    [routerLink]=\"{ cxRoute: 'termsAndConditions' } | cxUrl\"\n                    target=\"_blank\"\n                    rel=\"noopener noreferrer\"\n                  >\n                    {{ 'register.termsAndConditions' | cxTranslate }}\n                  </a>\n                  <ng-template\n                    [ngTemplateOutlet]=\"requiredAsterisk\"\n                  ></ng-template>\n                </span>\n\n                <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n                <cx-form-errors\n                  *cxFeature=\"'formErrorsDescriptiveMessages'\"\n                  [translationParams]=\"{\n                    label: 'register.termsAndConditions' | cxTranslate,\n                  }\"\n                  [control]=\"registerForm.get('termsandconditions')\"\n                ></cx-form-errors>\n\n                <cx-form-errors\n                  *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n                  [control]=\"registerForm.get('termsandconditions')\"\n                ></cx-form-errors>\n              </label>\n            </div>\n          </div>\n          <cx-captcha (confirmed)=\"captchaConfirmed()\"></cx-captcha>\n          <cx-form-errors\n            [control]=\"registerForm.get('captcha')\"\n          ></cx-form-errors>\n          <button type=\"submit\" class=\"btn btn-block btn-primary\">\n            {{ 'register.furtherRegistration' | cxTranslate }}\n          </button>\n          <a\n            class=\"cx-login-link btn-link\"\n            [routerLink]=\"{ cxRoute: 'login' } | cxUrl\"\n            >{{ 'register.signIn' | cxTranslate }}</a\n          >\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n"
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OneTimePasswordRegisterModule {
  static {
    this.ɵfac = function OneTimePasswordRegisterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OneTimePasswordRegisterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OneTimePasswordRegisterModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          RegisterCustomerWithOTPComponent: {
            component: OneTimePasswordRegisterComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegisterComponentService,
              useClass: RegisterComponentService,
              deps: [UserRegisterFacade, UntypedFormBuilder]
            }]
          }
        }
      })],
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, FeaturesConfigModule, BtnLikeLinkModule, ReactiveFormsModule, NgSelectModule, NgSelectA11yModule, CaptchaModule, SpinnerModule, FormErrorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OneTimePasswordRegisterModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, FeaturesConfigModule, BtnLikeLinkModule, ReactiveFormsModule, NgSelectModule, NgSelectA11yModule, CaptchaModule, SpinnerModule, FormErrorsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          RegisterCustomerWithOTPComponent: {
            component: OneTimePasswordRegisterComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegisterComponentService,
              useClass: RegisterComponentService,
              deps: [UserRegisterFacade, UntypedFormBuilder]
            }]
          }
        }
      })],
      declarations: [OneTimePasswordRegisterComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const globalMsgShowTime = 10000;
class RegistrationVerificationTokenFormComponentService {
  constructor() {
    this.globalMessageService = inject(GlobalMessageService);
    this.userRegisterFacade = inject(UserRegisterFacade);
    this.featureConfigService = inject(FeatureConfigService);
  }
  displayMessage(key, params) {
    this.globalMessageService.add({
      key: key,
      params
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION, globalMsgShowTime);
  }
  register(user) {
    return this.userRegisterFacade.register(user);
  }
  postRegisterMessage() {
    if (this.featureConfigService.isEnabled('a11yPostRegisterSuccessMessage')) {
      this.displayMessage('register.postRegisterSuccessMessage', globalMsgShowTime);
    } else {
      this.globalMessageService.add({
        key: 'register.postRegisterMessage'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  static {
    this.ɵfac = function RegistrationVerificationTokenFormComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegistrationVerificationTokenFormComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RegistrationVerificationTokenFormComponentService,
      factory: RegistrationVerificationTokenFormComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegistrationVerificationTokenFormComponentService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RegistrationVerificationTokenFormComponent {
  constructor() {
    this.fb = inject(UntypedFormBuilder);
    this.router = inject(RoutingService);
    this.authConfigService = inject(AuthConfigService);
    this.registrationVerificationTokenFacade = inject(VerificationTokenFacade);
    this.service = inject(RegistrationVerificationTokenFormComponentService);
    this.globalMessage = inject(GlobalMessageService);
    this.launchDialogService = inject(LaunchDialogService);
    this.featureConfigService = inject(FeatureConfigService);
    this.passwordValidators = this.getPasswordValidators();
    this.cdr = inject(ChangeDetectorRef);
    this.waitTime = 60;
    this.waitTimeForRateLimit = 300;
    this.registerForm = this.fb.group({
      password: ['', [Validators.required, ...this.passwordValidators]],
      passwordconf: ['', Validators.required],
      tokenCode: ['', Validators.required],
      titleCode: [''],
      firstName: [''],
      lastName: [''],
      email: [''],
      tokenId: ['']
    }, {
      validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf')
    });
    this.isLoading$ = new BehaviorSubject(false);
    this.isResendDisabled = true;
  }
  getPasswordValidators() {
    if (this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages')) {
      if (this.featureConfigService.isEnabled('enableSecurePasswordValidation')) {
        return CustomFormValidators.securePasswordValidators;
      } else {
        if (this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement')) {
          return [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters];
        } else {
          return CustomFormValidators.passwordValidators;
        }
      }
    } else {
      if (this.featureConfigService.isEnabled('enableSecurePasswordValidation')) {
        return CustomFormValidators.securePasswordValidator;
      } else {
        return CustomFormValidators.passwordValidators;
      }
    }
  }
  ngOnInit() {
    if (!!history.state) {
      this.tokenId = history.state['tokenId'];
      this.target = history.state['loginId'];
      this.titleCode = history.state['titleCode'];
      this.firstName = history.state['firstName'];
      this.lastName = history.state['lastName'];
      this.errorStatus = history.state['errorStatus'];
      history.pushState({
        tokenId: '',
        loginId: '',
        titleCode: '',
        firstName: '',
        lastName: '',
        errorStatus: ''
      }, 'verifyTokenForRegistration');
    }
    if (this.errorStatus === 400) {
      this.upToRateLimit = true;
      this.tokenId = 'invalidTokenId';
      this.startRateLimitWaitTimeInterval();
    } else if (!this.target || !this.tokenId || !this.firstName || !this.lastName) {
      this.router.go(['/login/register']);
    } else {
      this.startWaitTimeInterval();
      this.service.displayMessage('verificationTokenForm.createVerificationToken', {
        target: this.target
      });
    }
  }
  onSubmit() {
    if (this.registerForm.valid) {
      this.registerUserWithVerificationToken();
    } else {
      this.registerForm.markAllAsTouched();
    }
  }
  registerUserWithVerificationToken() {
    this.isLoading$.next(true);
    this.registerForm.setValue({
      titleCode: this.titleCode,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.target,
      tokenId: this.tokenId,
      password: this.registerForm.value.password,
      tokenCode: this.registerForm.value.tokenCode,
      passwordconf: this.registerForm.value.passwordconf
    });
    this.service.register(this.collectDataFromRegisterForm(this.registerForm.value)).subscribe({
      next: () => this.onRegisterUserSuccess(),
      complete: () => this.isLoading$.next(false),
      error: error => {
        if (error.status === 400) {
          this.registerForm.get('tokenCode')?.setErrors({
            invalidTokenCodeError: error.message
          });
          this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
        }
        this.isLoading$.next(false);
      }
    });
  }
  collectDataFromRegisterForm(formData) {
    const {
      email,
      firstName,
      lastName,
      password,
      titleCode,
      tokenId: verificationTokenId,
      tokenCode: verificationTokenCode
    } = formData;
    return {
      uid: email.toLowerCase(),
      firstName,
      lastName,
      password,
      titleCode,
      verificationTokenId,
      verificationTokenCode
    };
  }
  onRegisterUserSuccess() {
    if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
      this.router.go('login');
    }
    this.service.postRegisterMessage();
  }
  resendOTP() {
    this.isResendDisabled = true;
    this.resendLink.nativeElement.tabIndex = -1;
    this.waitTime = 60;
    this.startWaitTimeInterval();
    this.createRegistrationVerificationToken(this.target, ONE_TIME_PASSWORD_REGISTRATION_PURPOSE).subscribe({
      next: result => this.tokenId = result.tokenId,
      complete: () => this.service.displayMessage('verificationTokenForm.createVerificationToken', {
        target: this.target
      })
    });
  }
  createRegistrationVerificationToken(loginId, purpose) {
    return this.registrationVerificationTokenFacade.createVerificationToken({
      loginId,
      purpose
    });
  }
  startWaitTimeInterval() {
    const interval = setInterval(() => {
      this.waitTime--;
      this.cdr.detectChanges();
      if (this.waitTime <= 0) {
        clearInterval(interval);
        this.isResendDisabled = false;
        this.resendLink.nativeElement.tabIndex = 0;
        this.cdr.detectChanges();
      }
    }, 1000);
  }
  startRateLimitWaitTimeInterval() {
    const interval = setInterval(() => {
      this.waitTimeForRateLimit--;
      this.cdr.detectChanges();
      if (this.waitTimeForRateLimit <= 0) {
        clearInterval(interval);
        this.upToRateLimit = false;
        this.isResendDisabled = false;
        this.cdr.detectChanges();
      }
    }, 1000);
  }
  openInfoDailog() {
    this.launchDialogService.openDialogAndSubscribe("ACCOUNT_VERIFICATION_TOKEN" /* LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN */, this.element);
  }
  onOpenInfoDailogKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openInfoDailog();
    }
  }
  static {
    this.ɵfac = function RegistrationVerificationTokenFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegistrationVerificationTokenFormComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RegistrationVerificationTokenFormComponent,
      selectors: [["cx-registration-verification-token-form"]],
      viewQuery: function RegistrationVerificationTokenFormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c9, 5);
          i0.ɵɵviewQuery(_c10, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resendLink = _t.first);
        }
      },
      standalone: false,
      decls: 49,
      vars: 50,
      consts: [["requiredAsterisk", ""], ["loading", ""], ["resendLink", ""], ["noReceiveCodeLink", ""], [3, "ngSubmit", "formGroup"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "formControlName", "tokenCode", 1, "form-control", 3, "placeholder"], [3, "control"], ["class", "rate-limit-error-display", 4, "ngIf"], ["type", "hidden", "formControlName", "tokenId", 3, "ngModelChange", "ngModel"], ["class", "resend-link-text", 4, "ngIf"], [1, "form-group"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "password-input-hint", 1, "input-hint"], [3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "confirmpassword", "formControlName", "passwordconf", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], [1, "verify-container"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "btn", "btn-block", "btn-secondary", "btn-register", 3, "routerLink"], [1, "rate-limit-error-display"], [1, "resend-link-text"], [1, "left-text"], ["role", "timer", "aria-live", "polite", "aria-atomic", "true"], ["role", "button", "tabindex", "-1", 1, "btn-link", 3, "keydown.enter", "keydown.space", "click", "ngClass"], [4, "ngIf"], [1, "right-text"], ["role", "button", "tabindex", "0", 1, "btn-link", 3, "keydown", "click"], [3, "translationParams", "control"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"], [1, "cx-spinner"]],
      template: function RegistrationVerificationTokenFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "form", 4);
          i0.ɵɵlistener("ngSubmit", function RegistrationVerificationTokenFormComponent_Template_form_ngSubmit_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSubmit());
          });
          i0.ɵɵelementStart(1, "label")(2, "span", 5);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵtemplate(5, RegistrationVerificationTokenFormComponent_ng_template_5_Template, 0, 0, "ng-template", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(6, "input", 7);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelement(8, "cx-form-errors", 8);
          i0.ɵɵtemplate(9, RegistrationVerificationTokenFormComponent_div_9_Template, 3, 6, "div", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "input", 10);
          i0.ɵɵtwoWayListener("ngModelChange", function RegistrationVerificationTokenFormComponent_Template_input_ngModelChange_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.tokenId, $event) || (ctx.tokenId = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, RegistrationVerificationTokenFormComponent_div_11_Template, 13, 10, "div", 11);
          i0.ɵɵelementStart(12, "div", 12)(13, "label")(14, "span", 5);
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵtemplate(17, RegistrationVerificationTokenFormComponent_ng_template_17_Template, 0, 0, "ng-template", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(18, "input", 13);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵelementStart(21, "p", 14);
          i0.ɵɵtext(22);
          i0.ɵɵpipe(23, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(24, RegistrationVerificationTokenFormComponent_cx_form_errors_24_Template, 2, 6, "cx-form-errors", 15)(25, RegistrationVerificationTokenFormComponent_cx_form_errors_25_Template, 1, 1, "cx-form-errors", 16);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(26, "div", 12)(27, "label")(28, "span", 5);
          i0.ɵɵtext(29);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵtemplate(31, RegistrationVerificationTokenFormComponent_ng_template_31_Template, 0, 0, "ng-template", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(32, "input", 17);
          i0.ɵɵpipe(33, "cxTranslate");
          i0.ɵɵpipe(34, "cxTranslate");
          i0.ɵɵtemplate(35, RegistrationVerificationTokenFormComponent_cx_form_errors_35_Template, 2, 6, "cx-form-errors", 15)(36, RegistrationVerificationTokenFormComponent_cx_form_errors_36_Template, 1, 1, "cx-form-errors", 16);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(37, "div", 18)(38, "button", 19);
          i0.ɵɵtext(39);
          i0.ɵɵpipe(40, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(41, "button", 20);
          i0.ɵɵpipe(42, "cxUrl");
          i0.ɵɵtext(43);
          i0.ɵɵpipe(44, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(45, RegistrationVerificationTokenFormComponent_ng_template_45_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(47, RegistrationVerificationTokenFormComponent_ng_template_47_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const requiredAsterisk_r4 = i0.ɵɵreference(46);
          i0.ɵɵproperty("formGroup", ctx.registerForm);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 25, "verificationTokenForm.verificationCode.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 27, "verificationTokenForm.verificationCode.placeholder"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("control", ctx.registerForm.get("tokenCode"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.upToRateLimit);
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.tokenId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.upToRateLimit);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(16, 29, "register.password.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 31, "register.password.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(20, 33, "register.password.placeholder"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 35, "register.passwordMinRequirements"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 37, "register.confirmPassword.label"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(33, 39, "register.confirmPassword.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(34, 41, "register.confirmPassword.placeholder"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.registerForm.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 43, "register.register"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(42, 45, i0.ɵɵpureFunction0(49, _c11)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 47, "verificationTokenForm.back"), " ");
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i5.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i2.FeatureDirective, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegistrationVerificationTokenFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-registration-verification-token-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"registerForm\">\n  <label>\n    <span class=\"label-content\">\n      {{ 'verificationTokenForm.verificationCode.label' | cxTranslate }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n    ></span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      formControlName=\"tokenCode\"\n      placeholder=\"{{\n        'verificationTokenForm.verificationCode.placeholder' | cxTranslate\n      }}\"\n    />\n    <cx-form-errors [control]=\"registerForm.get('tokenCode')\"></cx-form-errors>\n    <div class=\"rate-limit-error-display\" *ngIf=\"upToRateLimit\">\n      {{\n        'register.rateLimitForRegistrationMessage'\n          | cxTranslate: { seconds: waitTimeForRateLimit }\n      }}\n    </div>\n  </label>\n\n  <input type=\"hidden\" formControlName=\"tokenId\" [(ngModel)]=\"tokenId\" />\n\n  <div *ngIf=\"!upToRateLimit\" class=\"resend-link-text\">\n    <div class=\"left-text\">\n      <span role=\"timer\" aria-live=\"polite\" aria-atomic=\"true\">\n        <a\n          role=\"button\"\n          tabindex=\"-1\"\n          #resendLink\n          (keydown.enter)=\"resendOTP()\"\n          (keydown.space)=\"resendOTP()\"\n          (click)=\"resendOTP()\"\n          class=\"btn-link\"\n          [ngClass]=\"{ 'disabled-link': isResendDisabled }\"\n        >\n          {{ 'verificationTokenForm.resend' | cxTranslate }}\n        </a>\n        <ng-container *ngIf=\"isResendDisabled\">\n          {{\n            'verificationTokenForm.sendRateLime'\n              | cxTranslate: { waitTime: waitTime }\n          }}\n        </ng-container>\n      </span>\n    </div>\n    <div class=\"right-text\">\n      <a\n        role=\"button\"\n        tabindex=\"0\"\n        #noReceiveCodeLink\n        (keydown)=\"onOpenInfoDailogKeyDown($event)\"\n        (click)=\"openInfoDailog()\"\n        class=\"btn-link\"\n      >\n        {{ 'verificationTokenForm.noReceiveCode' | cxTranslate }}\n      </a>\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content\"\n        >{{ 'register.password.label' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n      ></span>\n      <input\n        required=\"true\"\n        class=\"form-control\"\n        type=\"password\"\n        name=\"password\"\n        placeholder=\"{{ 'register.password.placeholder' | cxTranslate }}\"\n        formControlName=\"password\"\n        [attr.aria-label]=\"'register.password.placeholder' | cxTranslate\"\n        aria-describedby=\"password-input-hint\"\n        cxPasswordVisibilitySwitch\n      />\n      <p class=\"input-hint\" id=\"password-input-hint\">\n        {{ 'register.passwordMinRequirements' | cxTranslate }}\n      </p>\n\n      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n      <cx-form-errors\n        *cxFeature=\"'formErrorsDescriptiveMessages'\"\n        [translationParams]=\"{\n          label: 'register.password.label' | cxTranslate,\n        }\"\n        [control]=\"registerForm.get('password')\"\n      ></cx-form-errors>\n\n      <cx-form-errors\n        *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n        [control]=\"registerForm.get('password')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n\n  <div class=\"form-group\">\n    <label>\n      <span class=\"label-content\"\n        >{{ 'register.confirmPassword.label' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template\n      ></span>\n      <input\n        required=\"true\"\n        class=\"form-control\"\n        type=\"password\"\n        name=\"confirmpassword\"\n        placeholder=\"{{ 'register.confirmPassword.placeholder' | cxTranslate }}\"\n        formControlName=\"passwordconf\"\n        [attr.aria-label]=\"'register.confirmPassword.placeholder' | cxTranslate\"\n        cxPasswordVisibilitySwitch\n      />\n\n      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->\n      <cx-form-errors\n        *cxFeature=\"'formErrorsDescriptiveMessages'\"\n        [translationParams]=\"{\n          label: 'register.confirmPassword.label' | cxTranslate,\n        }\"\n        [control]=\"registerForm.get('passwordconf')\"\n      ></cx-form-errors>\n\n      <cx-form-errors\n        *cxFeature=\"'!formErrorsDescriptiveMessages'\"\n        [control]=\"registerForm.get('passwordconf')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n\n  <div class=\"verify-container\">\n    <button\n      type=\"submit\"\n      class=\"btn btn-block btn-primary\"\n      [disabled]=\"registerForm.disabled\"\n    >\n      {{ 'register.register' | cxTranslate }}\n    </button>\n    <button\n      [routerLink]=\"{ cxRoute: 'register' } | cxUrl\"\n      class=\"btn btn-block btn-secondary btn-register\"\n    >\n      {{ 'verificationTokenForm.back' | cxTranslate }}\n    </button>\n  </div>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    aria-hidden=\"true\"\n    class=\"text-decoration-none required-asterisk\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n"
    }]
  }], null, {
    element: [{
      type: ViewChild,
      args: ['noReceiveCodeLink']
    }],
    resendLink: [{
      type: ViewChild,
      args: ['resendLink']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RegistrationVerificationTokenFormModule {
  static {
    this.ɵfac = function RegistrationVerificationTokenFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegistrationVerificationTokenFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RegistrationVerificationTokenFormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          VerifyOTPForRegistrationComponent: {
            component: RegistrationVerificationTokenFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegistrationVerificationTokenFormComponentService,
              useClass: RegistrationVerificationTokenFormComponentService,
              deps: [GlobalMessageService, UserRegisterFacade]
            }]
          }
        }
      })],
      imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegistrationVerificationTokenFormModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          VerifyOTPForRegistrationComponent: {
            component: RegistrationVerificationTokenFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: RegistrationVerificationTokenFormComponentService,
              useClass: RegistrationVerificationTokenFormComponentService,
              deps: [GlobalMessageService, UserRegisterFacade]
            }]
          }
        }
      })],
      declarations: [RegistrationVerificationTokenFormComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserProfileComponentsModule {
  static {
    this.ɵfac = function UserProfileComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserProfileComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserProfileComponentsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [RegisterComponentModule, UpdateProfileModule, UpdateEmailModule, UpdatePasswordModule, ForgotPasswordModule, ResetPasswordModule, CloseAccountModule, AddressBookModule, OneTimePasswordRegisterModule, RegistrationVerificationTokenFormModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserProfileComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [RegisterComponentModule, UpdateProfileModule, UpdateEmailModule, UpdatePasswordModule, ForgotPasswordModule, ResetPasswordModule, CloseAccountModule, AddressBookModule, OneTimePasswordRegisterModule, RegistrationVerificationTokenFormModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressBookComponent, AddressBookComponentService, AddressBookModule, AddressFormComponent, AddressFormModule, CloseAccountComponent, CloseAccountModalComponent, CloseAccountModule, ForgotPasswordComponent, ForgotPasswordComponentService, ForgotPasswordModule, MyAccountV2EmailComponent, MyAccountV2PasswordComponent, MyAccountV2ProfileComponent, OneTimePasswordRegisterComponent, OneTimePasswordRegisterModule, RegisterComponent, RegisterComponentModule, RegisterComponentService, RegistrationVerificationTokenFormComponent, RegistrationVerificationTokenFormComponentService, RegistrationVerificationTokenFormModule, ResetPasswordComponent, ResetPasswordComponentService, ResetPasswordModule, SuggestedAddressDialogComponent, USE_MY_ACCOUNT_V2_EMAIL, USE_MY_ACCOUNT_V2_PASSWORD, USE_MY_ACCOUNT_V2_PROFILE, UpdateEmailComponent, UpdateEmailComponentService, UpdateEmailModule, UpdatePasswordComponent, UpdatePasswordComponentService, UpdatePasswordModule, UpdateProfileComponent, UpdateProfileComponentService, UpdateProfileModule, UserProfileComponentsModule };
